import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import {
    Api,
    EntitiesUpdateMeRequest,
    EntitiesGetActivityGraphResponse,
    EntitiesConversationAskQuestionResponse,
    EntitiesListRunningCoursesResponse,
    EntitiesConversationAskQuestionRequest,
    EntitiesRequestMessage,
    EntitiesCreateAssessmentResponse,
    EntitiesStartTrainingCourseResponse,
    EntitiesSuggestNewCertificatesResponse,
    EntitiesTTSRequest,
    EntitiesResponseMessage,
    EntitiesListTransactionsResponse,
    EntitiesJobsResponse,
    EntitiesStartTrainingCourseRequest,
    ModelUserDetails,
    EntitiesSkillBasedOnDescriptionRequest,
    EntitiesGetSkillScoreGraphResponse,
    EntitiesSuggestNewSkillsResponse,
    EntitiesCreateAssessmentRequest,
    EntitiesUpdateBillingSettingsRequest,
    EntitiesGetInterviewActivitiesResponse,
    EntitiesListAssessmentsResponse,
    EntitiesRespondToAssessmentTextRequest,
    EntitiesSkillBasedOnDescriptionResponse,
    EntitiesSignUpEmailRequest,
    EntitiesGetMeResponse,
    EntitiesGetAssessmentActivitiesResponse,
    EntitiesGetCourseActivitiesResponse,
    EntitiesConversationGenerateExampleRequest,
    EntitiesSignUpPasswordRequest,
    EntitiesConversationGenerateExampleResponse,
    EntitiesChangePasswordRequest,
    EntitiesListAssessmentTypesResponse,
    EntitiesGetBillingSettingsResponse,
    EntitiesListTrainingCoursesResponse,
    EntitiesLoginByResumeResponse,
    EntitiesDescribeResponse,
    EntitiesGetAssessmentsResponse,
    EntitiesGetBalanceResponse,
    RequestParams,
} from './api';

import AxiosAPI from './ApiConfig';

interface IuseApiV1ActivityAssessmentListState {
    isLoading: boolean;
    isExecuted: boolean;
    response?: EntitiesGetAssessmentActivitiesResponse;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    error?: any;
}

/**
 * URL:
 */
export const useApiV1ActivityAssessmentList = (
    params: RequestParams = {},
    autoExecute = true
) => {
    const [controller, setController] = useState(new AbortController());

    const api = new Api();
    api.instance = AxiosAPI;

    const [state, setState] = useState<IuseApiV1ActivityAssessmentListState>({
        isLoading: true,
        isExecuted: false,
    });
    const [lastInput, setLastInput] = useState<string>(
        JSON.stringify([params, autoExecute])
    );

    const sendRequest = (
        abortCtrl: AbortController,
        reqparams: RequestParams
    ) => {
        if (!api.instance.defaults.headers.common.Authorization) {
            return;
        }

        setState({
            ...state,
            error: undefined,
            isLoading: true,
            isExecuted: true,
        });
        try {
            const reqparamsSignal = { ...reqparams, signal: abortCtrl.signal };
            api.api
                .v1ActivityAssessmentList(reqparamsSignal)
                .then((resp) => {
                    setState({
                        ...state,
                        error: undefined,
                        response: resp.data,
                        isLoading: false,
                        isExecuted: true,
                    });
                })
                .catch((err) => {
                    if (
                        err.name === 'AbortError' ||
                        err.name === 'CanceledError'
                    ) {
                        // Request was aborted
                    } else {
                        setState({
                            ...state,
                            error: err,
                            response: undefined,
                            isLoading: false,
                            isExecuted: true,
                        });
                    }
                });
        } catch (err) {
            setState({
                ...state,
                error: err,
                isLoading: false,
                isExecuted: true,
            });
        }
    };

    if (JSON.stringify([params, autoExecute]) !== lastInput) {
        setLastInput(JSON.stringify([params, autoExecute]));
    }

    useEffect(() => {
        if (autoExecute) {
            controller.abort();
            const newController = new AbortController();
            setController(newController);
            sendRequest(newController, params);
        }
    }, [lastInput]);

    const { response } = state;
    const { isLoading } = state;
    const { isExecuted } = state;
    const { error } = state;
    const sendNow = () => {
        controller.abort();
        const newController = new AbortController();
        setController(newController);
        sendRequest(newController, params);
    };

    const sendNowWithParams = (reqparams: RequestParams) => {
        controller.abort();
        const newController = new AbortController();
        setController(newController);
        sendRequest(newController, reqparams);
    };

    return {
        response,
        isLoading,
        isExecuted,
        error,
        sendNow,
        sendNowWithParams,
    };
};

interface IuseApiV1ActivityCourseListState {
    isLoading: boolean;
    isExecuted: boolean;
    response?: EntitiesGetCourseActivitiesResponse;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    error?: any;
}

/**
 * URL:
 */
export const useApiV1ActivityCourseList = (
    params: RequestParams = {},
    autoExecute = true
) => {
    const [controller, setController] = useState(new AbortController());

    const api = new Api();
    api.instance = AxiosAPI;

    const [state, setState] = useState<IuseApiV1ActivityCourseListState>({
        isLoading: true,
        isExecuted: false,
    });
    const [lastInput, setLastInput] = useState<string>(
        JSON.stringify([params, autoExecute])
    );

    const sendRequest = (
        abortCtrl: AbortController,
        reqparams: RequestParams
    ) => {
        if (!api.instance.defaults.headers.common.Authorization) {
            return;
        }

        setState({
            ...state,
            error: undefined,
            isLoading: true,
            isExecuted: true,
        });
        try {
            const reqparamsSignal = { ...reqparams, signal: abortCtrl.signal };
            api.api
                .v1ActivityCourseList(reqparamsSignal)
                .then((resp) => {
                    setState({
                        ...state,
                        error: undefined,
                        response: resp.data,
                        isLoading: false,
                        isExecuted: true,
                    });
                })
                .catch((err) => {
                    if (
                        err.name === 'AbortError' ||
                        err.name === 'CanceledError'
                    ) {
                        // Request was aborted
                    } else {
                        setState({
                            ...state,
                            error: err,
                            response: undefined,
                            isLoading: false,
                            isExecuted: true,
                        });
                    }
                });
        } catch (err) {
            setState({
                ...state,
                error: err,
                isLoading: false,
                isExecuted: true,
            });
        }
    };

    if (JSON.stringify([params, autoExecute]) !== lastInput) {
        setLastInput(JSON.stringify([params, autoExecute]));
    }

    useEffect(() => {
        if (autoExecute) {
            controller.abort();
            const newController = new AbortController();
            setController(newController);
            sendRequest(newController, params);
        }
    }, [lastInput]);

    const { response } = state;
    const { isLoading } = state;
    const { isExecuted } = state;
    const { error } = state;
    const sendNow = () => {
        controller.abort();
        const newController = new AbortController();
        setController(newController);
        sendRequest(newController, params);
    };

    const sendNowWithParams = (reqparams: RequestParams) => {
        controller.abort();
        const newController = new AbortController();
        setController(newController);
        sendRequest(newController, reqparams);
    };

    return {
        response,
        isLoading,
        isExecuted,
        error,
        sendNow,
        sendNowWithParams,
    };
};

interface IuseApiV1ActivityGraphListState {
    isLoading: boolean;
    isExecuted: boolean;
    response?: EntitiesGetActivityGraphResponse;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    error?: any;
}

/**
 * URL:
 */
export const useApiV1ActivityGraphList = (
    params: RequestParams = {},
    autoExecute = true
) => {
    const [controller, setController] = useState(new AbortController());

    const api = new Api();
    api.instance = AxiosAPI;

    const [state, setState] = useState<IuseApiV1ActivityGraphListState>({
        isLoading: true,
        isExecuted: false,
    });
    const [lastInput, setLastInput] = useState<string>(
        JSON.stringify([params, autoExecute])
    );

    const sendRequest = (
        abortCtrl: AbortController,
        reqparams: RequestParams
    ) => {
        if (!api.instance.defaults.headers.common.Authorization) {
            return;
        }

        setState({
            ...state,
            error: undefined,
            isLoading: true,
            isExecuted: true,
        });
        try {
            const reqparamsSignal = { ...reqparams, signal: abortCtrl.signal };
            api.api
                .v1ActivityGraphList(reqparamsSignal)
                .then((resp) => {
                    setState({
                        ...state,
                        error: undefined,
                        response: resp.data,
                        isLoading: false,
                        isExecuted: true,
                    });
                })
                .catch((err) => {
                    if (
                        err.name === 'AbortError' ||
                        err.name === 'CanceledError'
                    ) {
                        // Request was aborted
                    } else {
                        setState({
                            ...state,
                            error: err,
                            response: undefined,
                            isLoading: false,
                            isExecuted: true,
                        });
                    }
                });
        } catch (err) {
            setState({
                ...state,
                error: err,
                isLoading: false,
                isExecuted: true,
            });
        }
    };

    if (JSON.stringify([params, autoExecute]) !== lastInput) {
        setLastInput(JSON.stringify([params, autoExecute]));
    }

    useEffect(() => {
        if (autoExecute) {
            controller.abort();
            const newController = new AbortController();
            setController(newController);
            sendRequest(newController, params);
        }
    }, [lastInput]);

    const { response } = state;
    const { isLoading } = state;
    const { isExecuted } = state;
    const { error } = state;
    const sendNow = () => {
        controller.abort();
        const newController = new AbortController();
        setController(newController);
        sendRequest(newController, params);
    };

    const sendNowWithParams = (reqparams: RequestParams) => {
        controller.abort();
        const newController = new AbortController();
        setController(newController);
        sendRequest(newController, reqparams);
    };

    return {
        response,
        isLoading,
        isExecuted,
        error,
        sendNow,
        sendNowWithParams,
    };
};

interface IuseApiV1ActivityInterviewListState {
    isLoading: boolean;
    isExecuted: boolean;
    response?: EntitiesGetInterviewActivitiesResponse;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    error?: any;
}

/**
 * URL:
 */
export const useApiV1ActivityInterviewList = (
    params: RequestParams = {},
    autoExecute = true
) => {
    const [controller, setController] = useState(new AbortController());

    const api = new Api();
    api.instance = AxiosAPI;

    const [state, setState] = useState<IuseApiV1ActivityInterviewListState>({
        isLoading: true,
        isExecuted: false,
    });
    const [lastInput, setLastInput] = useState<string>(
        JSON.stringify([params, autoExecute])
    );

    const sendRequest = (
        abortCtrl: AbortController,
        reqparams: RequestParams
    ) => {
        if (!api.instance.defaults.headers.common.Authorization) {
            return;
        }

        setState({
            ...state,
            error: undefined,
            isLoading: true,
            isExecuted: true,
        });
        try {
            const reqparamsSignal = { ...reqparams, signal: abortCtrl.signal };
            api.api
                .v1ActivityInterviewList(reqparamsSignal)
                .then((resp) => {
                    setState({
                        ...state,
                        error: undefined,
                        response: resp.data,
                        isLoading: false,
                        isExecuted: true,
                    });
                })
                .catch((err) => {
                    if (
                        err.name === 'AbortError' ||
                        err.name === 'CanceledError'
                    ) {
                        // Request was aborted
                    } else {
                        setState({
                            ...state,
                            error: err,
                            response: undefined,
                            isLoading: false,
                            isExecuted: true,
                        });
                    }
                });
        } catch (err) {
            setState({
                ...state,
                error: err,
                isLoading: false,
                isExecuted: true,
            });
        }
    };

    if (JSON.stringify([params, autoExecute]) !== lastInput) {
        setLastInput(JSON.stringify([params, autoExecute]));
    }

    useEffect(() => {
        if (autoExecute) {
            controller.abort();
            const newController = new AbortController();
            setController(newController);
            sendRequest(newController, params);
        }
    }, [lastInput]);

    const { response } = state;
    const { isLoading } = state;
    const { isExecuted } = state;
    const { error } = state;
    const sendNow = () => {
        controller.abort();
        const newController = new AbortController();
        setController(newController);
        sendRequest(newController, params);
    };

    const sendNowWithParams = (reqparams: RequestParams) => {
        controller.abort();
        const newController = new AbortController();
        setController(newController);
        sendRequest(newController, reqparams);
    };

    return {
        response,
        isLoading,
        isExecuted,
        error,
        sendNow,
        sendNowWithParams,
    };
};

interface IuseApiV1AssessmentListState {
    isLoading: boolean;
    isExecuted: boolean;
    response?: EntitiesListAssessmentsResponse;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    error?: any;
}

/**
 * URL:
 */
export const useApiV1AssessmentList = (
    params: RequestParams = {},
    autoExecute = true
) => {
    const [controller, setController] = useState(new AbortController());

    const api = new Api();
    api.instance = AxiosAPI;

    const [state, setState] = useState<IuseApiV1AssessmentListState>({
        isLoading: true,
        isExecuted: false,
    });
    const [lastInput, setLastInput] = useState<string>(
        JSON.stringify([params, autoExecute])
    );

    const sendRequest = (
        abortCtrl: AbortController,
        reqparams: RequestParams
    ) => {
        if (!api.instance.defaults.headers.common.Authorization) {
            return;
        }

        setState({
            ...state,
            error: undefined,
            isLoading: true,
            isExecuted: true,
        });
        try {
            const reqparamsSignal = { ...reqparams, signal: abortCtrl.signal };
            api.api
                .v1AssessmentList(reqparamsSignal)
                .then((resp) => {
                    setState({
                        ...state,
                        error: undefined,
                        response: resp.data,
                        isLoading: false,
                        isExecuted: true,
                    });
                })
                .catch((err) => {
                    if (
                        err.name === 'AbortError' ||
                        err.name === 'CanceledError'
                    ) {
                        // Request was aborted
                    } else {
                        setState({
                            ...state,
                            error: err,
                            response: undefined,
                            isLoading: false,
                            isExecuted: true,
                        });
                    }
                });
        } catch (err) {
            setState({
                ...state,
                error: err,
                isLoading: false,
                isExecuted: true,
            });
        }
    };

    if (JSON.stringify([params, autoExecute]) !== lastInput) {
        setLastInput(JSON.stringify([params, autoExecute]));
    }

    useEffect(() => {
        if (autoExecute) {
            controller.abort();
            const newController = new AbortController();
            setController(newController);
            sendRequest(newController, params);
        }
    }, [lastInput]);

    const { response } = state;
    const { isLoading } = state;
    const { isExecuted } = state;
    const { error } = state;
    const sendNow = () => {
        controller.abort();
        const newController = new AbortController();
        setController(newController);
        sendRequest(newController, params);
    };

    const sendNowWithParams = (reqparams: RequestParams) => {
        controller.abort();
        const newController = new AbortController();
        setController(newController);
        sendRequest(newController, reqparams);
    };

    return {
        response,
        isLoading,
        isExecuted,
        error,
        sendNow,
        sendNowWithParams,
    };
};

interface IuseApiV1AssessmentCreateState {
    isLoading: boolean;
    isExecuted: boolean;
    response?: EntitiesCreateAssessmentResponse;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    error?: any;
}

/**
 * URL:
 */
export const useApiV1AssessmentCreate = (
    request: EntitiesCreateAssessmentRequest,
    params: RequestParams = {},
    autoExecute = true
) => {
    const [controller, setController] = useState(new AbortController());

    const api = new Api();
    api.instance = AxiosAPI;

    const [state, setState] = useState<IuseApiV1AssessmentCreateState>({
        isLoading: true,
        isExecuted: false,
    });
    const [lastInput, setLastInput] = useState<string>(
        JSON.stringify([request, params, autoExecute])
    );

    const sendRequest = (
        abortCtrl: AbortController,
        reqrequest: EntitiesCreateAssessmentRequest,
        reqparams: RequestParams
    ) => {
        if (!api.instance.defaults.headers.common.Authorization) {
            return;
        }

        setState({
            ...state,
            error: undefined,
            isLoading: true,
            isExecuted: true,
        });
        try {
            const reqparamsSignal = { ...reqparams, signal: abortCtrl.signal };
            api.api
                .v1AssessmentCreate(reqrequest, reqparamsSignal)
                .then((resp) => {
                    setState({
                        ...state,
                        error: undefined,
                        response: resp.data,
                        isLoading: false,
                        isExecuted: true,
                    });
                })
                .catch((err) => {
                    if (
                        err.name === 'AbortError' ||
                        err.name === 'CanceledError'
                    ) {
                        // Request was aborted
                    } else {
                        setState({
                            ...state,
                            error: err,
                            response: undefined,
                            isLoading: false,
                            isExecuted: true,
                        });
                    }
                });
        } catch (err) {
            setState({
                ...state,
                error: err,
                isLoading: false,
                isExecuted: true,
            });
        }
    };

    if (JSON.stringify([request, params, autoExecute]) !== lastInput) {
        setLastInput(JSON.stringify([request, params, autoExecute]));
    }

    useEffect(() => {
        if (autoExecute) {
            controller.abort();
            const newController = new AbortController();
            setController(newController);
            sendRequest(newController, request, params);
        }
    }, [lastInput]);

    const { response } = state;
    const { isLoading } = state;
    const { isExecuted } = state;
    const { error } = state;
    const sendNow = () => {
        controller.abort();
        const newController = new AbortController();
        setController(newController);
        sendRequest(newController, request, params);
    };

    const sendNowWithParams = (
        reqrequest: EntitiesCreateAssessmentRequest,
        reqparams: RequestParams
    ) => {
        controller.abort();
        const newController = new AbortController();
        setController(newController);
        sendRequest(newController, reqrequest, reqparams);
    };

    return {
        response,
        isLoading,
        isExecuted,
        error,
        sendNow,
        sendNowWithParams,
    };
};

interface IuseApiV1AssessmentTypesListState {
    isLoading: boolean;
    isExecuted: boolean;
    response?: EntitiesListAssessmentTypesResponse;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    error?: any;
}

/**
 * URL:
 */
export const useApiV1AssessmentTypesList = (
    params: RequestParams = {},
    autoExecute = true
) => {
    const [controller, setController] = useState(new AbortController());

    const api = new Api();
    api.instance = AxiosAPI;

    const [state, setState] = useState<IuseApiV1AssessmentTypesListState>({
        isLoading: true,
        isExecuted: false,
    });
    const [lastInput, setLastInput] = useState<string>(
        JSON.stringify([params, autoExecute])
    );

    const sendRequest = (
        abortCtrl: AbortController,
        reqparams: RequestParams
    ) => {
        if (!api.instance.defaults.headers.common.Authorization) {
            return;
        }

        setState({
            ...state,
            error: undefined,
            isLoading: true,
            isExecuted: true,
        });
        try {
            const reqparamsSignal = { ...reqparams, signal: abortCtrl.signal };
            api.api
                .v1AssessmentTypesList(reqparamsSignal)
                .then((resp) => {
                    setState({
                        ...state,
                        error: undefined,
                        response: resp.data,
                        isLoading: false,
                        isExecuted: true,
                    });
                })
                .catch((err) => {
                    if (
                        err.name === 'AbortError' ||
                        err.name === 'CanceledError'
                    ) {
                        // Request was aborted
                    } else {
                        setState({
                            ...state,
                            error: err,
                            response: undefined,
                            isLoading: false,
                            isExecuted: true,
                        });
                    }
                });
        } catch (err) {
            setState({
                ...state,
                error: err,
                isLoading: false,
                isExecuted: true,
            });
        }
    };

    if (JSON.stringify([params, autoExecute]) !== lastInput) {
        setLastInput(JSON.stringify([params, autoExecute]));
    }

    useEffect(() => {
        if (autoExecute) {
            controller.abort();
            const newController = new AbortController();
            setController(newController);
            sendRequest(newController, params);
        }
    }, [lastInput]);

    const { response } = state;
    const { isLoading } = state;
    const { isExecuted } = state;
    const { error } = state;
    const sendNow = () => {
        controller.abort();
        const newController = new AbortController();
        setController(newController);
        sendRequest(newController, params);
    };

    const sendNowWithParams = (reqparams: RequestParams) => {
        controller.abort();
        const newController = new AbortController();
        setController(newController);
        sendRequest(newController, reqparams);
    };

    return {
        response,
        isLoading,
        isExecuted,
        error,
        sendNow,
        sendNowWithParams,
    };
};

interface IuseApiV1AssessmentDetailState {
    isLoading: boolean;
    isExecuted: boolean;
    response?: EntitiesGetAssessmentsResponse;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    error?: any;
}

/**
 * URL:
 */
export const useApiV1AssessmentDetail = (
    assessmentId: number,
    params: RequestParams = {},
    autoExecute = true
) => {
    const [controller, setController] = useState(new AbortController());

    const api = new Api();
    api.instance = AxiosAPI;

    const [state, setState] = useState<IuseApiV1AssessmentDetailState>({
        isLoading: true,
        isExecuted: false,
    });
    const [lastInput, setLastInput] = useState<string>(
        JSON.stringify([assessmentId, params, autoExecute])
    );

    const sendRequest = (
        abortCtrl: AbortController,
        reqassessmentId: number,
        reqparams: RequestParams
    ) => {
        if (!api.instance.defaults.headers.common.Authorization) {
            return;
        }

        setState({
            ...state,
            error: undefined,
            isLoading: true,
            isExecuted: true,
        });
        try {
            const reqparamsSignal = { ...reqparams, signal: abortCtrl.signal };
            api.api
                .v1AssessmentDetail(reqassessmentId, reqparamsSignal)
                .then((resp) => {
                    setState({
                        ...state,
                        error: undefined,
                        response: resp.data,
                        isLoading: false,
                        isExecuted: true,
                    });
                })
                .catch((err) => {
                    if (
                        err.name === 'AbortError' ||
                        err.name === 'CanceledError'
                    ) {
                        // Request was aborted
                    } else {
                        setState({
                            ...state,
                            error: err,
                            response: undefined,
                            isLoading: false,
                            isExecuted: true,
                        });
                    }
                });
        } catch (err) {
            setState({
                ...state,
                error: err,
                isLoading: false,
                isExecuted: true,
            });
        }
    };

    if (JSON.stringify([assessmentId, params, autoExecute]) !== lastInput) {
        setLastInput(JSON.stringify([assessmentId, params, autoExecute]));
    }

    useEffect(() => {
        if (autoExecute) {
            controller.abort();
            const newController = new AbortController();
            setController(newController);
            sendRequest(newController, assessmentId, params);
        }
    }, [lastInput]);

    const { response } = state;
    const { isLoading } = state;
    const { isExecuted } = state;
    const { error } = state;
    const sendNow = () => {
        controller.abort();
        const newController = new AbortController();
        setController(newController);
        sendRequest(newController, assessmentId, params);
    };

    const sendNowWithParams = (
        reqassessmentId: number,
        reqparams: RequestParams
    ) => {
        controller.abort();
        const newController = new AbortController();
        setController(newController);
        sendRequest(newController, reqassessmentId, reqparams);
    };

    return {
        response,
        isLoading,
        isExecuted,
        error,
        sendNow,
        sendNowWithParams,
    };
};

interface IuseApiV1AssessmentDeleteState {
    isLoading: boolean;
    isExecuted: boolean;
    response?: void;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    error?: any;
}

/**
 * URL:
 */
export const useApiV1AssessmentDelete = (
    assessmentId: number,
    params: RequestParams = {},
    autoExecute = true
) => {
    const [controller, setController] = useState(new AbortController());

    const api = new Api();
    api.instance = AxiosAPI;

    const [state, setState] = useState<IuseApiV1AssessmentDeleteState>({
        isLoading: true,
        isExecuted: false,
    });
    const [lastInput, setLastInput] = useState<string>(
        JSON.stringify([assessmentId, params, autoExecute])
    );

    const sendRequest = (
        abortCtrl: AbortController,
        reqassessmentId: number,
        reqparams: RequestParams
    ) => {
        if (!api.instance.defaults.headers.common.Authorization) {
            return;
        }

        setState({
            ...state,
            error: undefined,
            isLoading: true,
            isExecuted: true,
        });
        try {
            const reqparamsSignal = { ...reqparams, signal: abortCtrl.signal };
            api.api
                .v1AssessmentDelete(reqassessmentId, reqparamsSignal)
                .then((resp) => {
                    setState({
                        ...state,
                        error: undefined,
                        response: resp.data,
                        isLoading: false,
                        isExecuted: true,
                    });
                })
                .catch((err) => {
                    if (
                        err.name === 'AbortError' ||
                        err.name === 'CanceledError'
                    ) {
                        // Request was aborted
                    } else {
                        setState({
                            ...state,
                            error: err,
                            response: undefined,
                            isLoading: false,
                            isExecuted: true,
                        });
                    }
                });
        } catch (err) {
            setState({
                ...state,
                error: err,
                isLoading: false,
                isExecuted: true,
            });
        }
    };

    if (JSON.stringify([assessmentId, params, autoExecute]) !== lastInput) {
        setLastInput(JSON.stringify([assessmentId, params, autoExecute]));
    }

    useEffect(() => {
        if (autoExecute) {
            controller.abort();
            const newController = new AbortController();
            setController(newController);
            sendRequest(newController, assessmentId, params);
        }
    }, [lastInput]);

    const { response } = state;
    const { isLoading } = state;
    const { isExecuted } = state;
    const { error } = state;
    const sendNow = () => {
        controller.abort();
        const newController = new AbortController();
        setController(newController);
        sendRequest(newController, assessmentId, params);
    };

    const sendNowWithParams = (
        reqassessmentId: number,
        reqparams: RequestParams
    ) => {
        controller.abort();
        const newController = new AbortController();
        setController(newController);
        sendRequest(newController, reqassessmentId, reqparams);
    };

    return {
        response,
        isLoading,
        isExecuted,
        error,
        sendNow,
        sendNowWithParams,
    };
};

interface IuseApiV1AssessmentRespondTextCreateState {
    isLoading: boolean;
    isExecuted: boolean;
    response?: void;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    error?: any;
}

/**
 * URL:
 */
export const useApiV1AssessmentRespondTextCreate = (
    assessmentId: number,
    request: EntitiesRespondToAssessmentTextRequest,
    params: RequestParams = {},
    autoExecute = true
) => {
    const [controller, setController] = useState(new AbortController());

    const api = new Api();
    api.instance = AxiosAPI;

    const [state, setState] =
        useState<IuseApiV1AssessmentRespondTextCreateState>({
            isLoading: true,
            isExecuted: false,
        });
    const [lastInput, setLastInput] = useState<string>(
        JSON.stringify([assessmentId, request, params, autoExecute])
    );

    const sendRequest = (
        abortCtrl: AbortController,
        reqassessmentId: number,
        reqrequest: EntitiesRespondToAssessmentTextRequest,
        reqparams: RequestParams
    ) => {
        if (!api.instance.defaults.headers.common.Authorization) {
            return;
        }

        setState({
            ...state,
            error: undefined,
            isLoading: true,
            isExecuted: true,
        });
        try {
            const reqparamsSignal = { ...reqparams, signal: abortCtrl.signal };
            api.api
                .v1AssessmentRespondTextCreate(
                    reqassessmentId,
                    reqrequest,
                    reqparamsSignal
                )
                .then((resp) => {
                    setState({
                        ...state,
                        error: undefined,
                        response: resp.data,
                        isLoading: false,
                        isExecuted: true,
                    });
                })
                .catch((err) => {
                    if (
                        err.name === 'AbortError' ||
                        err.name === 'CanceledError'
                    ) {
                        // Request was aborted
                    } else {
                        setState({
                            ...state,
                            error: err,
                            response: undefined,
                            isLoading: false,
                            isExecuted: true,
                        });
                    }
                });
        } catch (err) {
            setState({
                ...state,
                error: err,
                isLoading: false,
                isExecuted: true,
            });
        }
    };

    if (
        JSON.stringify([assessmentId, request, params, autoExecute]) !==
        lastInput
    ) {
        setLastInput(
            JSON.stringify([assessmentId, request, params, autoExecute])
        );
    }

    useEffect(() => {
        if (autoExecute) {
            controller.abort();
            const newController = new AbortController();
            setController(newController);
            sendRequest(newController, assessmentId, request, params);
        }
    }, [lastInput]);

    const { response } = state;
    const { isLoading } = state;
    const { isExecuted } = state;
    const { error } = state;
    const sendNow = () => {
        controller.abort();
        const newController = new AbortController();
        setController(newController);
        sendRequest(newController, assessmentId, request, params);
    };

    const sendNowWithParams = (
        reqassessmentId: number,
        reqrequest: EntitiesRespondToAssessmentTextRequest,
        reqparams: RequestParams
    ) => {
        controller.abort();
        const newController = new AbortController();
        setController(newController);
        sendRequest(newController, reqassessmentId, reqrequest, reqparams);
    };

    return {
        response,
        isLoading,
        isExecuted,
        error,
        sendNow,
        sendNowWithParams,
    };
};

interface IuseApiV1AssessmentRespondVoiceCreateState {
    isLoading: boolean;
    isExecuted: boolean;
    response?: void;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    error?: any;
}

/**
 * URL:
 */
export const useApiV1AssessmentRespondVoiceCreate = (
    assessmentId: number,
    data: {
        'voice-response': File;
    },
    params: RequestParams = {},
    autoExecute = true
) => {
    const [controller, setController] = useState(new AbortController());

    const api = new Api();
    api.instance = AxiosAPI;

    const [state, setState] =
        useState<IuseApiV1AssessmentRespondVoiceCreateState>({
            isLoading: true,
            isExecuted: false,
        });
    const [lastInput, setLastInput] = useState<string>(
        JSON.stringify([assessmentId, data, params, autoExecute])
    );

    const sendRequest = (
        abortCtrl: AbortController,
        reqassessmentId: number,
        reqdata: {
            'voice-response': File;
        },
        reqparams: RequestParams
    ) => {
        if (!api.instance.defaults.headers.common.Authorization) {
            return;
        }

        setState({
            ...state,
            error: undefined,
            isLoading: true,
            isExecuted: true,
        });
        try {
            const reqparamsSignal = { ...reqparams, signal: abortCtrl.signal };
            api.api
                .v1AssessmentRespondVoiceCreate(
                    reqassessmentId,
                    reqdata,
                    reqparamsSignal
                )
                .then((resp) => {
                    setState({
                        ...state,
                        error: undefined,
                        response: resp.data,
                        isLoading: false,
                        isExecuted: true,
                    });
                })
                .catch((err) => {
                    if (
                        err.name === 'AbortError' ||
                        err.name === 'CanceledError'
                    ) {
                        // Request was aborted
                    } else {
                        setState({
                            ...state,
                            error: err,
                            response: undefined,
                            isLoading: false,
                            isExecuted: true,
                        });
                    }
                });
        } catch (err) {
            setState({
                ...state,
                error: err,
                isLoading: false,
                isExecuted: true,
            });
        }
    };

    if (
        JSON.stringify([assessmentId, data, params, autoExecute]) !== lastInput
    ) {
        setLastInput(JSON.stringify([assessmentId, data, params, autoExecute]));
    }

    useEffect(() => {
        if (autoExecute) {
            controller.abort();
            const newController = new AbortController();
            setController(newController);
            sendRequest(newController, assessmentId, data, params);
        }
    }, [lastInput]);

    const { response } = state;
    const { isLoading } = state;
    const { isExecuted } = state;
    const { error } = state;
    const sendNow = () => {
        controller.abort();
        const newController = new AbortController();
        setController(newController);
        sendRequest(newController, assessmentId, data, params);
    };

    const sendNowWithParams = (
        reqassessmentId: number,
        reqdata: {
            'voice-response': File;
        },
        reqparams: RequestParams
    ) => {
        controller.abort();
        const newController = new AbortController();
        setController(newController);
        sendRequest(newController, reqassessmentId, reqdata, reqparams);
    };

    return {
        response,
        isLoading,
        isExecuted,
        error,
        sendNow,
        sendNowWithParams,
    };
};

interface IuseApiV1BillingBalanceListState {
    isLoading: boolean;
    isExecuted: boolean;
    response?: EntitiesGetBalanceResponse;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    error?: any;
}

/**
 * URL:
 */
export const useApiV1BillingBalanceList = (
    params: RequestParams = {},
    autoExecute = true
) => {
    const [controller, setController] = useState(new AbortController());

    const api = new Api();
    api.instance = AxiosAPI;

    const [state, setState] = useState<IuseApiV1BillingBalanceListState>({
        isLoading: true,
        isExecuted: false,
    });
    const [lastInput, setLastInput] = useState<string>(
        JSON.stringify([params, autoExecute])
    );

    const sendRequest = (
        abortCtrl: AbortController,
        reqparams: RequestParams
    ) => {
        if (!api.instance.defaults.headers.common.Authorization) {
            return;
        }

        setState({
            ...state,
            error: undefined,
            isLoading: true,
            isExecuted: true,
        });
        try {
            const reqparamsSignal = { ...reqparams, signal: abortCtrl.signal };
            api.api
                .v1BillingBalanceList(reqparamsSignal)
                .then((resp) => {
                    setState({
                        ...state,
                        error: undefined,
                        response: resp.data,
                        isLoading: false,
                        isExecuted: true,
                    });
                })
                .catch((err) => {
                    if (
                        err.name === 'AbortError' ||
                        err.name === 'CanceledError'
                    ) {
                        // Request was aborted
                    } else {
                        setState({
                            ...state,
                            error: err,
                            response: undefined,
                            isLoading: false,
                            isExecuted: true,
                        });
                    }
                });
        } catch (err) {
            setState({
                ...state,
                error: err,
                isLoading: false,
                isExecuted: true,
            });
        }
    };

    if (JSON.stringify([params, autoExecute]) !== lastInput) {
        setLastInput(JSON.stringify([params, autoExecute]));
    }

    useEffect(() => {
        if (autoExecute) {
            controller.abort();
            const newController = new AbortController();
            setController(newController);
            sendRequest(newController, params);
        }
    }, [lastInput]);

    const { response } = state;
    const { isLoading } = state;
    const { isExecuted } = state;
    const { error } = state;
    const sendNow = () => {
        controller.abort();
        const newController = new AbortController();
        setController(newController);
        sendRequest(newController, params);
    };

    const sendNowWithParams = (reqparams: RequestParams) => {
        controller.abort();
        const newController = new AbortController();
        setController(newController);
        sendRequest(newController, reqparams);
    };

    return {
        response,
        isLoading,
        isExecuted,
        error,
        sendNow,
        sendNowWithParams,
    };
};

interface IuseApiV1BillingSettingsListState {
    isLoading: boolean;
    isExecuted: boolean;
    response?: EntitiesGetBillingSettingsResponse;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    error?: any;
}

/**
 * URL:
 */
export const useApiV1BillingSettingsList = (
    params: RequestParams = {},
    autoExecute = true
) => {
    const [controller, setController] = useState(new AbortController());

    const api = new Api();
    api.instance = AxiosAPI;

    const [state, setState] = useState<IuseApiV1BillingSettingsListState>({
        isLoading: true,
        isExecuted: false,
    });
    const [lastInput, setLastInput] = useState<string>(
        JSON.stringify([params, autoExecute])
    );

    const sendRequest = (
        abortCtrl: AbortController,
        reqparams: RequestParams
    ) => {
        if (!api.instance.defaults.headers.common.Authorization) {
            return;
        }

        setState({
            ...state,
            error: undefined,
            isLoading: true,
            isExecuted: true,
        });
        try {
            const reqparamsSignal = { ...reqparams, signal: abortCtrl.signal };
            api.api
                .v1BillingSettingsList(reqparamsSignal)
                .then((resp) => {
                    setState({
                        ...state,
                        error: undefined,
                        response: resp.data,
                        isLoading: false,
                        isExecuted: true,
                    });
                })
                .catch((err) => {
                    if (
                        err.name === 'AbortError' ||
                        err.name === 'CanceledError'
                    ) {
                        // Request was aborted
                    } else {
                        setState({
                            ...state,
                            error: err,
                            response: undefined,
                            isLoading: false,
                            isExecuted: true,
                        });
                    }
                });
        } catch (err) {
            setState({
                ...state,
                error: err,
                isLoading: false,
                isExecuted: true,
            });
        }
    };

    if (JSON.stringify([params, autoExecute]) !== lastInput) {
        setLastInput(JSON.stringify([params, autoExecute]));
    }

    useEffect(() => {
        if (autoExecute) {
            controller.abort();
            const newController = new AbortController();
            setController(newController);
            sendRequest(newController, params);
        }
    }, [lastInput]);

    const { response } = state;
    const { isLoading } = state;
    const { isExecuted } = state;
    const { error } = state;
    const sendNow = () => {
        controller.abort();
        const newController = new AbortController();
        setController(newController);
        sendRequest(newController, params);
    };

    const sendNowWithParams = (reqparams: RequestParams) => {
        controller.abort();
        const newController = new AbortController();
        setController(newController);
        sendRequest(newController, reqparams);
    };

    return {
        response,
        isLoading,
        isExecuted,
        error,
        sendNow,
        sendNowWithParams,
    };
};

interface IuseApiV1BillingSettingsCreateState {
    isLoading: boolean;
    isExecuted: boolean;
    response?: void;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    error?: any;
}

/**
 * URL:
 */
export const useApiV1BillingSettingsCreate = (
    request: EntitiesUpdateBillingSettingsRequest,
    params: RequestParams = {},
    autoExecute = true
) => {
    const [controller, setController] = useState(new AbortController());

    const api = new Api();
    api.instance = AxiosAPI;

    const [state, setState] = useState<IuseApiV1BillingSettingsCreateState>({
        isLoading: true,
        isExecuted: false,
    });
    const [lastInput, setLastInput] = useState<string>(
        JSON.stringify([request, params, autoExecute])
    );

    const sendRequest = (
        abortCtrl: AbortController,
        reqrequest: EntitiesUpdateBillingSettingsRequest,
        reqparams: RequestParams
    ) => {
        if (!api.instance.defaults.headers.common.Authorization) {
            return;
        }

        setState({
            ...state,
            error: undefined,
            isLoading: true,
            isExecuted: true,
        });
        try {
            const reqparamsSignal = { ...reqparams, signal: abortCtrl.signal };
            api.api
                .v1BillingSettingsCreate(reqrequest, reqparamsSignal)
                .then((resp) => {
                    setState({
                        ...state,
                        error: undefined,
                        response: resp.data,
                        isLoading: false,
                        isExecuted: true,
                    });
                })
                .catch((err) => {
                    if (
                        err.name === 'AbortError' ||
                        err.name === 'CanceledError'
                    ) {
                        // Request was aborted
                    } else {
                        setState({
                            ...state,
                            error: err,
                            response: undefined,
                            isLoading: false,
                            isExecuted: true,
                        });
                    }
                });
        } catch (err) {
            setState({
                ...state,
                error: err,
                isLoading: false,
                isExecuted: true,
            });
        }
    };

    if (JSON.stringify([request, params, autoExecute]) !== lastInput) {
        setLastInput(JSON.stringify([request, params, autoExecute]));
    }

    useEffect(() => {
        if (autoExecute) {
            controller.abort();
            const newController = new AbortController();
            setController(newController);
            sendRequest(newController, request, params);
        }
    }, [lastInput]);

    const { response } = state;
    const { isLoading } = state;
    const { isExecuted } = state;
    const { error } = state;
    const sendNow = () => {
        controller.abort();
        const newController = new AbortController();
        setController(newController);
        sendRequest(newController, request, params);
    };

    const sendNowWithParams = (
        reqrequest: EntitiesUpdateBillingSettingsRequest,
        reqparams: RequestParams
    ) => {
        controller.abort();
        const newController = new AbortController();
        setController(newController);
        sendRequest(newController, reqrequest, reqparams);
    };

    return {
        response,
        isLoading,
        isExecuted,
        error,
        sendNow,
        sendNowWithParams,
    };
};

interface IuseApiV1BillingTransactionsListState {
    isLoading: boolean;
    isExecuted: boolean;
    response?: EntitiesListTransactionsResponse;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    error?: any;
}

/**
 * URL:
 */
export const useApiV1BillingTransactionsList = (
    params: RequestParams = {},
    autoExecute = true
) => {
    const [controller, setController] = useState(new AbortController());

    const api = new Api();
    api.instance = AxiosAPI;

    const [state, setState] = useState<IuseApiV1BillingTransactionsListState>({
        isLoading: true,
        isExecuted: false,
    });
    const [lastInput, setLastInput] = useState<string>(
        JSON.stringify([params, autoExecute])
    );

    const sendRequest = (
        abortCtrl: AbortController,
        reqparams: RequestParams
    ) => {
        if (!api.instance.defaults.headers.common.Authorization) {
            return;
        }

        setState({
            ...state,
            error: undefined,
            isLoading: true,
            isExecuted: true,
        });
        try {
            const reqparamsSignal = { ...reqparams, signal: abortCtrl.signal };
            api.api
                .v1BillingTransactionsList(reqparamsSignal)
                .then((resp) => {
                    setState({
                        ...state,
                        error: undefined,
                        response: resp.data,
                        isLoading: false,
                        isExecuted: true,
                    });
                })
                .catch((err) => {
                    if (
                        err.name === 'AbortError' ||
                        err.name === 'CanceledError'
                    ) {
                        // Request was aborted
                    } else {
                        setState({
                            ...state,
                            error: err,
                            response: undefined,
                            isLoading: false,
                            isExecuted: true,
                        });
                    }
                });
        } catch (err) {
            setState({
                ...state,
                error: err,
                isLoading: false,
                isExecuted: true,
            });
        }
    };

    if (JSON.stringify([params, autoExecute]) !== lastInput) {
        setLastInput(JSON.stringify([params, autoExecute]));
    }

    useEffect(() => {
        if (autoExecute) {
            controller.abort();
            const newController = new AbortController();
            setController(newController);
            sendRequest(newController, params);
        }
    }, [lastInput]);

    const { response } = state;
    const { isLoading } = state;
    const { isExecuted } = state;
    const { error } = state;
    const sendNow = () => {
        controller.abort();
        const newController = new AbortController();
        setController(newController);
        sendRequest(newController, params);
    };

    const sendNowWithParams = (reqparams: RequestParams) => {
        controller.abort();
        const newController = new AbortController();
        setController(newController);
        sendRequest(newController, reqparams);
    };

    return {
        response,
        isLoading,
        isExecuted,
        error,
        sendNow,
        sendNowWithParams,
    };
};

interface IuseApiV1CourseListState {
    isLoading: boolean;
    isExecuted: boolean;
    response?: EntitiesListTrainingCoursesResponse;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    error?: any;
}

/**
 * URL:
 */
export const useApiV1CourseList = (
    params: RequestParams = {},
    autoExecute = true
) => {
    const [controller, setController] = useState(new AbortController());

    const api = new Api();
    api.instance = AxiosAPI;

    const [state, setState] = useState<IuseApiV1CourseListState>({
        isLoading: true,
        isExecuted: false,
    });
    const [lastInput, setLastInput] = useState<string>(
        JSON.stringify([params, autoExecute])
    );

    const sendRequest = (
        abortCtrl: AbortController,
        reqparams: RequestParams
    ) => {
        if (!api.instance.defaults.headers.common.Authorization) {
            return;
        }

        setState({
            ...state,
            error: undefined,
            isLoading: true,
            isExecuted: true,
        });
        try {
            const reqparamsSignal = { ...reqparams, signal: abortCtrl.signal };
            api.api
                .v1CourseList(reqparamsSignal)
                .then((resp) => {
                    setState({
                        ...state,
                        error: undefined,
                        response: resp.data,
                        isLoading: false,
                        isExecuted: true,
                    });
                })
                .catch((err) => {
                    if (
                        err.name === 'AbortError' ||
                        err.name === 'CanceledError'
                    ) {
                        // Request was aborted
                    } else {
                        setState({
                            ...state,
                            error: err,
                            response: undefined,
                            isLoading: false,
                            isExecuted: true,
                        });
                    }
                });
        } catch (err) {
            setState({
                ...state,
                error: err,
                isLoading: false,
                isExecuted: true,
            });
        }
    };

    if (JSON.stringify([params, autoExecute]) !== lastInput) {
        setLastInput(JSON.stringify([params, autoExecute]));
    }

    useEffect(() => {
        if (autoExecute) {
            controller.abort();
            const newController = new AbortController();
            setController(newController);
            sendRequest(newController, params);
        }
    }, [lastInput]);

    const { response } = state;
    const { isLoading } = state;
    const { isExecuted } = state;
    const { error } = state;
    const sendNow = () => {
        controller.abort();
        const newController = new AbortController();
        setController(newController);
        sendRequest(newController, params);
    };

    const sendNowWithParams = (reqparams: RequestParams) => {
        controller.abort();
        const newController = new AbortController();
        setController(newController);
        sendRequest(newController, reqparams);
    };

    return {
        response,
        isLoading,
        isExecuted,
        error,
        sendNow,
        sendNowWithParams,
    };
};

interface IuseApiV1CourseCreateState {
    isLoading: boolean;
    isExecuted: boolean;
    response?: EntitiesStartTrainingCourseResponse;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    error?: any;
}

/**
 * URL:
 */
export const useApiV1CourseCreate = (
    request: EntitiesStartTrainingCourseRequest,
    params: RequestParams = {},
    autoExecute = true
) => {
    const [controller, setController] = useState(new AbortController());

    const api = new Api();
    api.instance = AxiosAPI;

    const [state, setState] = useState<IuseApiV1CourseCreateState>({
        isLoading: true,
        isExecuted: false,
    });
    const [lastInput, setLastInput] = useState<string>(
        JSON.stringify([request, params, autoExecute])
    );

    const sendRequest = (
        abortCtrl: AbortController,
        reqrequest: EntitiesStartTrainingCourseRequest,
        reqparams: RequestParams
    ) => {
        if (!api.instance.defaults.headers.common.Authorization) {
            return;
        }

        setState({
            ...state,
            error: undefined,
            isLoading: true,
            isExecuted: true,
        });
        try {
            const reqparamsSignal = { ...reqparams, signal: abortCtrl.signal };
            api.api
                .v1CourseCreate(reqrequest, reqparamsSignal)
                .then((resp) => {
                    setState({
                        ...state,
                        error: undefined,
                        response: resp.data,
                        isLoading: false,
                        isExecuted: true,
                    });
                })
                .catch((err) => {
                    if (
                        err.name === 'AbortError' ||
                        err.name === 'CanceledError'
                    ) {
                        // Request was aborted
                    } else {
                        setState({
                            ...state,
                            error: err,
                            response: undefined,
                            isLoading: false,
                            isExecuted: true,
                        });
                    }
                });
        } catch (err) {
            setState({
                ...state,
                error: err,
                isLoading: false,
                isExecuted: true,
            });
        }
    };

    if (JSON.stringify([request, params, autoExecute]) !== lastInput) {
        setLastInput(JSON.stringify([request, params, autoExecute]));
    }

    useEffect(() => {
        if (autoExecute) {
            controller.abort();
            const newController = new AbortController();
            setController(newController);
            sendRequest(newController, request, params);
        }
    }, [lastInput]);

    const { response } = state;
    const { isLoading } = state;
    const { isExecuted } = state;
    const { error } = state;
    const sendNow = () => {
        controller.abort();
        const newController = new AbortController();
        setController(newController);
        sendRequest(newController, request, params);
    };

    const sendNowWithParams = (
        reqrequest: EntitiesStartTrainingCourseRequest,
        reqparams: RequestParams
    ) => {
        controller.abort();
        const newController = new AbortController();
        setController(newController);
        sendRequest(newController, reqrequest, reqparams);
    };

    return {
        response,
        isLoading,
        isExecuted,
        error,
        sendNow,
        sendNowWithParams,
    };
};

interface IuseApiV1CourseListListState {
    isLoading: boolean;
    isExecuted: boolean;
    response?: EntitiesListRunningCoursesResponse;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    error?: any;
}

/**
 * URL:
 */
export const useApiV1CourseListList = (
    params: RequestParams = {},
    autoExecute = true
) => {
    const [controller, setController] = useState(new AbortController());

    const api = new Api();
    api.instance = AxiosAPI;

    const [state, setState] = useState<IuseApiV1CourseListListState>({
        isLoading: true,
        isExecuted: false,
    });
    const [lastInput, setLastInput] = useState<string>(
        JSON.stringify([params, autoExecute])
    );

    const sendRequest = (
        abortCtrl: AbortController,
        reqparams: RequestParams
    ) => {
        if (!api.instance.defaults.headers.common.Authorization) {
            return;
        }

        setState({
            ...state,
            error: undefined,
            isLoading: true,
            isExecuted: true,
        });
        try {
            const reqparamsSignal = { ...reqparams, signal: abortCtrl.signal };
            api.api
                .v1CourseListList(reqparamsSignal)
                .then((resp) => {
                    setState({
                        ...state,
                        error: undefined,
                        response: resp.data,
                        isLoading: false,
                        isExecuted: true,
                    });
                })
                .catch((err) => {
                    if (
                        err.name === 'AbortError' ||
                        err.name === 'CanceledError'
                    ) {
                        // Request was aborted
                    } else {
                        setState({
                            ...state,
                            error: err,
                            response: undefined,
                            isLoading: false,
                            isExecuted: true,
                        });
                    }
                });
        } catch (err) {
            setState({
                ...state,
                error: err,
                isLoading: false,
                isExecuted: true,
            });
        }
    };

    if (JSON.stringify([params, autoExecute]) !== lastInput) {
        setLastInput(JSON.stringify([params, autoExecute]));
    }

    useEffect(() => {
        if (autoExecute) {
            controller.abort();
            const newController = new AbortController();
            setController(newController);
            sendRequest(newController, params);
        }
    }, [lastInput]);

    const { response } = state;
    const { isLoading } = state;
    const { isExecuted } = state;
    const { error } = state;
    const sendNow = () => {
        controller.abort();
        const newController = new AbortController();
        setController(newController);
        sendRequest(newController, params);
    };

    const sendNowWithParams = (reqparams: RequestParams) => {
        controller.abort();
        const newController = new AbortController();
        setController(newController);
        sendRequest(newController, reqparams);
    };

    return {
        response,
        isLoading,
        isExecuted,
        error,
        sendNow,
        sendNowWithParams,
    };
};

interface IuseApiV1CourseConversationExampleCreateState {
    isLoading: boolean;
    isExecuted: boolean;
    response?: EntitiesConversationGenerateExampleResponse;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    error?: any;
}

/**
 * URL:
 */
export const useApiV1CourseConversationExampleCreate = (
    id: number,
    request: EntitiesConversationGenerateExampleRequest,
    params: RequestParams = {},
    autoExecute = true
) => {
    const [controller, setController] = useState(new AbortController());

    const api = new Api();
    api.instance = AxiosAPI;

    const [state, setState] =
        useState<IuseApiV1CourseConversationExampleCreateState>({
            isLoading: true,
            isExecuted: false,
        });
    const [lastInput, setLastInput] = useState<string>(
        JSON.stringify([id, request, params, autoExecute])
    );

    const sendRequest = (
        abortCtrl: AbortController,
        reqid: number,
        reqrequest: EntitiesConversationGenerateExampleRequest,
        reqparams: RequestParams
    ) => {
        if (!api.instance.defaults.headers.common.Authorization) {
            return;
        }

        setState({
            ...state,
            error: undefined,
            isLoading: true,
            isExecuted: true,
        });
        try {
            const reqparamsSignal = { ...reqparams, signal: abortCtrl.signal };
            api.api
                .v1CourseConversationExampleCreate(
                    reqid,
                    reqrequest,
                    reqparamsSignal
                )
                .then((resp) => {
                    setState({
                        ...state,
                        error: undefined,
                        response: resp.data,
                        isLoading: false,
                        isExecuted: true,
                    });
                })
                .catch((err) => {
                    if (
                        err.name === 'AbortError' ||
                        err.name === 'CanceledError'
                    ) {
                        // Request was aborted
                    } else {
                        setState({
                            ...state,
                            error: err,
                            response: undefined,
                            isLoading: false,
                            isExecuted: true,
                        });
                    }
                });
        } catch (err) {
            setState({
                ...state,
                error: err,
                isLoading: false,
                isExecuted: true,
            });
        }
    };

    if (JSON.stringify([id, request, params, autoExecute]) !== lastInput) {
        setLastInput(JSON.stringify([id, request, params, autoExecute]));
    }

    useEffect(() => {
        if (autoExecute) {
            controller.abort();
            const newController = new AbortController();
            setController(newController);
            sendRequest(newController, id, request, params);
        }
    }, [lastInput]);

    const { response } = state;
    const { isLoading } = state;
    const { isExecuted } = state;
    const { error } = state;
    const sendNow = () => {
        controller.abort();
        const newController = new AbortController();
        setController(newController);
        sendRequest(newController, id, request, params);
    };

    const sendNowWithParams = (
        reqid: number,
        reqrequest: EntitiesConversationGenerateExampleRequest,
        reqparams: RequestParams
    ) => {
        controller.abort();
        const newController = new AbortController();
        setController(newController);
        sendRequest(newController, reqid, reqrequest, reqparams);
    };

    return {
        response,
        isLoading,
        isExecuted,
        error,
        sendNow,
        sendNowWithParams,
    };
};

interface IuseApiV1CourseConversationQuestionCreateState {
    isLoading: boolean;
    isExecuted: boolean;
    response?: EntitiesConversationAskQuestionResponse;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    error?: any;
}

/**
 * URL:
 */
export const useApiV1CourseConversationQuestionCreate = (
    id: number,
    request: EntitiesConversationAskQuestionRequest,
    params: RequestParams = {},
    autoExecute = true
) => {
    const [controller, setController] = useState(new AbortController());

    const api = new Api();
    api.instance = AxiosAPI;

    const [state, setState] =
        useState<IuseApiV1CourseConversationQuestionCreateState>({
            isLoading: true,
            isExecuted: false,
        });
    const [lastInput, setLastInput] = useState<string>(
        JSON.stringify([id, request, params, autoExecute])
    );

    const sendRequest = (
        abortCtrl: AbortController,
        reqid: number,
        reqrequest: EntitiesConversationAskQuestionRequest,
        reqparams: RequestParams
    ) => {
        if (!api.instance.defaults.headers.common.Authorization) {
            return;
        }

        setState({
            ...state,
            error: undefined,
            isLoading: true,
            isExecuted: true,
        });
        try {
            const reqparamsSignal = { ...reqparams, signal: abortCtrl.signal };
            api.api
                .v1CourseConversationQuestionCreate(
                    reqid,
                    reqrequest,
                    reqparamsSignal
                )
                .then((resp) => {
                    setState({
                        ...state,
                        error: undefined,
                        response: resp.data,
                        isLoading: false,
                        isExecuted: true,
                    });
                })
                .catch((err) => {
                    if (
                        err.name === 'AbortError' ||
                        err.name === 'CanceledError'
                    ) {
                        // Request was aborted
                    } else {
                        setState({
                            ...state,
                            error: err,
                            response: undefined,
                            isLoading: false,
                            isExecuted: true,
                        });
                    }
                });
        } catch (err) {
            setState({
                ...state,
                error: err,
                isLoading: false,
                isExecuted: true,
            });
        }
    };

    if (JSON.stringify([id, request, params, autoExecute]) !== lastInput) {
        setLastInput(JSON.stringify([id, request, params, autoExecute]));
    }

    useEffect(() => {
        if (autoExecute) {
            controller.abort();
            const newController = new AbortController();
            setController(newController);
            sendRequest(newController, id, request, params);
        }
    }, [lastInput]);

    const { response } = state;
    const { isLoading } = state;
    const { isExecuted } = state;
    const { error } = state;
    const sendNow = () => {
        controller.abort();
        const newController = new AbortController();
        setController(newController);
        sendRequest(newController, id, request, params);
    };

    const sendNowWithParams = (
        reqid: number,
        reqrequest: EntitiesConversationAskQuestionRequest,
        reqparams: RequestParams
    ) => {
        controller.abort();
        const newController = new AbortController();
        setController(newController);
        sendRequest(newController, reqid, reqrequest, reqparams);
    };

    return {
        response,
        isLoading,
        isExecuted,
        error,
        sendNow,
        sendNowWithParams,
    };
};

interface IuseApiV1JobsListState {
    isLoading: boolean;
    isExecuted: boolean;
    response?: EntitiesJobsResponse;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    error?: any;
}

/**
 * URL:
 */
export const useApiV1JobsList = (
    params: RequestParams = {},
    autoExecute = true
) => {
    const [controller, setController] = useState(new AbortController());

    const api = new Api();
    api.instance = AxiosAPI;

    const [state, setState] = useState<IuseApiV1JobsListState>({
        isLoading: true,
        isExecuted: false,
    });
    const [lastInput, setLastInput] = useState<string>(
        JSON.stringify([params, autoExecute])
    );

    const sendRequest = (
        abortCtrl: AbortController,
        reqparams: RequestParams
    ) => {
        if (!api.instance.defaults.headers.common.Authorization) {
            return;
        }

        setState({
            ...state,
            error: undefined,
            isLoading: true,
            isExecuted: true,
        });
        try {
            const reqparamsSignal = { ...reqparams, signal: abortCtrl.signal };
            api.api
                .v1JobsList(reqparamsSignal)
                .then((resp) => {
                    setState({
                        ...state,
                        error: undefined,
                        response: resp.data,
                        isLoading: false,
                        isExecuted: true,
                    });
                })
                .catch((err) => {
                    if (
                        err.name === 'AbortError' ||
                        err.name === 'CanceledError'
                    ) {
                        // Request was aborted
                    } else {
                        setState({
                            ...state,
                            error: err,
                            response: undefined,
                            isLoading: false,
                            isExecuted: true,
                        });
                    }
                });
        } catch (err) {
            setState({
                ...state,
                error: err,
                isLoading: false,
                isExecuted: true,
            });
        }
    };

    if (JSON.stringify([params, autoExecute]) !== lastInput) {
        setLastInput(JSON.stringify([params, autoExecute]));
    }

    useEffect(() => {
        if (autoExecute) {
            controller.abort();
            const newController = new AbortController();
            setController(newController);
            sendRequest(newController, params);
        }
    }, [lastInput]);

    const { response } = state;
    const { isLoading } = state;
    const { isExecuted } = state;
    const { error } = state;
    const sendNow = () => {
        controller.abort();
        const newController = new AbortController();
        setController(newController);
        sendRequest(newController, params);
    };

    const sendNowWithParams = (reqparams: RequestParams) => {
        controller.abort();
        const newController = new AbortController();
        setController(newController);
        sendRequest(newController, reqparams);
    };

    return {
        response,
        isLoading,
        isExecuted,
        error,
        sendNow,
        sendNowWithParams,
    };
};

interface IuseApiV1LoginResumeUpdateState {
    isLoading: boolean;
    isExecuted: boolean;
    response?: EntitiesLoginByResumeResponse;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    error?: any;
}

/**
 * URL:
 */
export const useApiV1LoginResumeUpdate = (
    data: {
        file: File;
    },
    params: RequestParams = {},
    autoExecute = true
) => {
    const [controller, setController] = useState(new AbortController());

    const api = new Api();
    api.instance = AxiosAPI;

    const [state, setState] = useState<IuseApiV1LoginResumeUpdateState>({
        isLoading: true,
        isExecuted: false,
    });
    const [lastInput, setLastInput] = useState<string>(
        JSON.stringify([data, params, autoExecute])
    );

    const sendRequest = (
        abortCtrl: AbortController,
        reqdata: {
            file: File;
        },
        reqparams: RequestParams
    ) => {
        if (!api.instance.defaults.headers.common.Authorization) {
            return;
        }

        setState({
            ...state,
            error: undefined,
            isLoading: true,
            isExecuted: true,
        });
        try {
            const reqparamsSignal = { ...reqparams, signal: abortCtrl.signal };
            api.api
                .v1LoginResumeUpdate(reqdata, reqparamsSignal)
                .then((resp) => {
                    setState({
                        ...state,
                        error: undefined,
                        response: resp.data,
                        isLoading: false,
                        isExecuted: true,
                    });
                })
                .catch((err) => {
                    if (
                        err.name === 'AbortError' ||
                        err.name === 'CanceledError'
                    ) {
                        // Request was aborted
                    } else {
                        setState({
                            ...state,
                            error: err,
                            response: undefined,
                            isLoading: false,
                            isExecuted: true,
                        });
                    }
                });
        } catch (err) {
            setState({
                ...state,
                error: err,
                isLoading: false,
                isExecuted: true,
            });
        }
    };

    if (JSON.stringify([data, params, autoExecute]) !== lastInput) {
        setLastInput(JSON.stringify([data, params, autoExecute]));
    }

    useEffect(() => {
        if (autoExecute) {
            controller.abort();
            const newController = new AbortController();
            setController(newController);
            sendRequest(newController, data, params);
        }
    }, [lastInput]);

    const { response } = state;
    const { isLoading } = state;
    const { isExecuted } = state;
    const { error } = state;
    const sendNow = () => {
        controller.abort();
        const newController = new AbortController();
        setController(newController);
        sendRequest(newController, data, params);
    };

    const sendNowWithParams = (
        reqdata: {
            file: File;
        },
        reqparams: RequestParams
    ) => {
        controller.abort();
        const newController = new AbortController();
        setController(newController);
        sendRequest(newController, reqdata, reqparams);
    };

    return {
        response,
        isLoading,
        isExecuted,
        error,
        sendNow,
        sendNowWithParams,
    };
};

interface IuseApiV1ProfileDescribeAboutMeCreateState {
    isLoading: boolean;
    isExecuted: boolean;
    response?: EntitiesDescribeResponse;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    error?: any;
}

/**
 * URL:
 */
export const useApiV1ProfileDescribeAboutMeCreate = (
    params: RequestParams = {},
    autoExecute = true
) => {
    const [controller, setController] = useState(new AbortController());

    const api = new Api();
    api.instance = AxiosAPI;

    const [state, setState] =
        useState<IuseApiV1ProfileDescribeAboutMeCreateState>({
            isLoading: true,
            isExecuted: false,
        });
    const [lastInput, setLastInput] = useState<string>(
        JSON.stringify([params, autoExecute])
    );

    const sendRequest = (
        abortCtrl: AbortController,
        reqparams: RequestParams
    ) => {
        if (!api.instance.defaults.headers.common.Authorization) {
            return;
        }

        setState({
            ...state,
            error: undefined,
            isLoading: true,
            isExecuted: true,
        });
        try {
            const reqparamsSignal = { ...reqparams, signal: abortCtrl.signal };
            api.api
                .v1ProfileDescribeAboutMeCreate(reqparamsSignal)
                .then((resp) => {
                    setState({
                        ...state,
                        error: undefined,
                        response: resp.data,
                        isLoading: false,
                        isExecuted: true,
                    });
                })
                .catch((err) => {
                    if (
                        err.name === 'AbortError' ||
                        err.name === 'CanceledError'
                    ) {
                        // Request was aborted
                    } else {
                        setState({
                            ...state,
                            error: err,
                            response: undefined,
                            isLoading: false,
                            isExecuted: true,
                        });
                    }
                });
        } catch (err) {
            setState({
                ...state,
                error: err,
                isLoading: false,
                isExecuted: true,
            });
        }
    };

    if (JSON.stringify([params, autoExecute]) !== lastInput) {
        setLastInput(JSON.stringify([params, autoExecute]));
    }

    useEffect(() => {
        if (autoExecute) {
            controller.abort();
            const newController = new AbortController();
            setController(newController);
            sendRequest(newController, params);
        }
    }, [lastInput]);

    const { response } = state;
    const { isLoading } = state;
    const { isExecuted } = state;
    const { error } = state;
    const sendNow = () => {
        controller.abort();
        const newController = new AbortController();
        setController(newController);
        sendRequest(newController, params);
    };

    const sendNowWithParams = (reqparams: RequestParams) => {
        controller.abort();
        const newController = new AbortController();
        setController(newController);
        sendRequest(newController, reqparams);
    };

    return {
        response,
        isLoading,
        isExecuted,
        error,
        sendNow,
        sendNowWithParams,
    };
};

interface IuseApiV1ProfileDescribeProjectsCreateState {
    isLoading: boolean;
    isExecuted: boolean;
    response?: EntitiesDescribeResponse;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    error?: any;
}

/**
 * URL:
 */
export const useApiV1ProfileDescribeProjectsCreate = (
    params: RequestParams = {},
    autoExecute = true
) => {
    const [controller, setController] = useState(new AbortController());

    const api = new Api();
    api.instance = AxiosAPI;

    const [state, setState] =
        useState<IuseApiV1ProfileDescribeProjectsCreateState>({
            isLoading: true,
            isExecuted: false,
        });
    const [lastInput, setLastInput] = useState<string>(
        JSON.stringify([params, autoExecute])
    );

    const sendRequest = (
        abortCtrl: AbortController,
        reqparams: RequestParams
    ) => {
        if (!api.instance.defaults.headers.common.Authorization) {
            return;
        }

        setState({
            ...state,
            error: undefined,
            isLoading: true,
            isExecuted: true,
        });
        try {
            const reqparamsSignal = { ...reqparams, signal: abortCtrl.signal };
            api.api
                .v1ProfileDescribeProjectsCreate(reqparamsSignal)
                .then((resp) => {
                    setState({
                        ...state,
                        error: undefined,
                        response: resp.data,
                        isLoading: false,
                        isExecuted: true,
                    });
                })
                .catch((err) => {
                    if (
                        err.name === 'AbortError' ||
                        err.name === 'CanceledError'
                    ) {
                        // Request was aborted
                    } else {
                        setState({
                            ...state,
                            error: err,
                            response: undefined,
                            isLoading: false,
                            isExecuted: true,
                        });
                    }
                });
        } catch (err) {
            setState({
                ...state,
                error: err,
                isLoading: false,
                isExecuted: true,
            });
        }
    };

    if (JSON.stringify([params, autoExecute]) !== lastInput) {
        setLastInput(JSON.stringify([params, autoExecute]));
    }

    useEffect(() => {
        if (autoExecute) {
            controller.abort();
            const newController = new AbortController();
            setController(newController);
            sendRequest(newController, params);
        }
    }, [lastInput]);

    const { response } = state;
    const { isLoading } = state;
    const { isExecuted } = state;
    const { error } = state;
    const sendNow = () => {
        controller.abort();
        const newController = new AbortController();
        setController(newController);
        sendRequest(newController, params);
    };

    const sendNowWithParams = (reqparams: RequestParams) => {
        controller.abort();
        const newController = new AbortController();
        setController(newController);
        sendRequest(newController, reqparams);
    };

    return {
        response,
        isLoading,
        isExecuted,
        error,
        sendNow,
        sendNowWithParams,
    };
};

interface IuseApiV1ProfileDescribeWorkExperienceCreateState {
    isLoading: boolean;
    isExecuted: boolean;
    response?: EntitiesDescribeResponse;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    error?: any;
}

/**
 * URL:
 */
export const useApiV1ProfileDescribeWorkExperienceCreate = (
    params: RequestParams = {},
    autoExecute = true
) => {
    const [controller, setController] = useState(new AbortController());

    const api = new Api();
    api.instance = AxiosAPI;

    const [state, setState] =
        useState<IuseApiV1ProfileDescribeWorkExperienceCreateState>({
            isLoading: true,
            isExecuted: false,
        });
    const [lastInput, setLastInput] = useState<string>(
        JSON.stringify([params, autoExecute])
    );

    const sendRequest = (
        abortCtrl: AbortController,
        reqparams: RequestParams
    ) => {
        if (!api.instance.defaults.headers.common.Authorization) {
            return;
        }

        setState({
            ...state,
            error: undefined,
            isLoading: true,
            isExecuted: true,
        });
        try {
            const reqparamsSignal = { ...reqparams, signal: abortCtrl.signal };
            api.api
                .v1ProfileDescribeWorkExperienceCreate(reqparamsSignal)
                .then((resp) => {
                    setState({
                        ...state,
                        error: undefined,
                        response: resp.data,
                        isLoading: false,
                        isExecuted: true,
                    });
                })
                .catch((err) => {
                    if (
                        err.name === 'AbortError' ||
                        err.name === 'CanceledError'
                    ) {
                        // Request was aborted
                    } else {
                        setState({
                            ...state,
                            error: err,
                            response: undefined,
                            isLoading: false,
                            isExecuted: true,
                        });
                    }
                });
        } catch (err) {
            setState({
                ...state,
                error: err,
                isLoading: false,
                isExecuted: true,
            });
        }
    };

    if (JSON.stringify([params, autoExecute]) !== lastInput) {
        setLastInput(JSON.stringify([params, autoExecute]));
    }

    useEffect(() => {
        if (autoExecute) {
            controller.abort();
            const newController = new AbortController();
            setController(newController);
            sendRequest(newController, params);
        }
    }, [lastInput]);

    const { response } = state;
    const { isLoading } = state;
    const { isExecuted } = state;
    const { error } = state;
    const sendNow = () => {
        controller.abort();
        const newController = new AbortController();
        setController(newController);
        sendRequest(newController, params);
    };

    const sendNowWithParams = (reqparams: RequestParams) => {
        controller.abort();
        const newController = new AbortController();
        setController(newController);
        sendRequest(newController, reqparams);
    };

    return {
        response,
        isLoading,
        isExecuted,
        error,
        sendNow,
        sendNowWithParams,
    };
};

interface IuseApiV1ProfileResumeUpdateState {
    isLoading: boolean;
    isExecuted: boolean;
    response?: ModelUserDetails;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    error?: any;
}

/**
 * URL:
 */
export const useApiV1ProfileResumeUpdate = (
    data: {
        file: File;
    },
    params: RequestParams = {},
    autoExecute = true
) => {
    const [controller, setController] = useState(new AbortController());

    const api = new Api();
    api.instance = AxiosAPI;

    const [state, setState] = useState<IuseApiV1ProfileResumeUpdateState>({
        isLoading: true,
        isExecuted: false,
    });
    const [lastInput, setLastInput] = useState<string>(
        JSON.stringify([data, params, autoExecute])
    );

    const sendRequest = (
        abortCtrl: AbortController,
        reqdata: {
            file: File;
        },
        reqparams: RequestParams
    ) => {
        if (!api.instance.defaults.headers.common.Authorization) {
            return;
        }

        setState({
            ...state,
            error: undefined,
            isLoading: true,
            isExecuted: true,
        });
        try {
            const reqparamsSignal = { ...reqparams, signal: abortCtrl.signal };
            api.api
                .v1ProfileResumeUpdate(reqdata, reqparamsSignal)
                .then((resp) => {
                    setState({
                        ...state,
                        error: undefined,
                        response: resp.data,
                        isLoading: false,
                        isExecuted: true,
                    });
                })
                .catch((err) => {
                    if (
                        err.name === 'AbortError' ||
                        err.name === 'CanceledError'
                    ) {
                        // Request was aborted
                    } else {
                        setState({
                            ...state,
                            error: err,
                            response: undefined,
                            isLoading: false,
                            isExecuted: true,
                        });
                    }
                });
        } catch (err) {
            setState({
                ...state,
                error: err,
                isLoading: false,
                isExecuted: true,
            });
        }
    };

    if (JSON.stringify([data, params, autoExecute]) !== lastInput) {
        setLastInput(JSON.stringify([data, params, autoExecute]));
    }

    useEffect(() => {
        if (autoExecute) {
            controller.abort();
            const newController = new AbortController();
            setController(newController);
            sendRequest(newController, data, params);
        }
    }, [lastInput]);

    const { response } = state;
    const { isLoading } = state;
    const { isExecuted } = state;
    const { error } = state;
    const sendNow = () => {
        controller.abort();
        const newController = new AbortController();
        setController(newController);
        sendRequest(newController, data, params);
    };

    const sendNowWithParams = (
        reqdata: {
            file: File;
        },
        reqparams: RequestParams
    ) => {
        controller.abort();
        const newController = new AbortController();
        setController(newController);
        sendRequest(newController, reqdata, reqparams);
    };

    return {
        response,
        isLoading,
        isExecuted,
        error,
        sendNow,
        sendNowWithParams,
    };
};

interface IuseApiV1ProfileSkillsDescriptionCreateState {
    isLoading: boolean;
    isExecuted: boolean;
    response?: EntitiesSkillBasedOnDescriptionResponse;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    error?: any;
}

/**
 * URL:
 */
export const useApiV1ProfileSkillsDescriptionCreate = (
    request: EntitiesSkillBasedOnDescriptionRequest,
    params: RequestParams = {},
    autoExecute = true
) => {
    const [controller, setController] = useState(new AbortController());

    const api = new Api();
    api.instance = AxiosAPI;

    const [state, setState] =
        useState<IuseApiV1ProfileSkillsDescriptionCreateState>({
            isLoading: true,
            isExecuted: false,
        });
    const [lastInput, setLastInput] = useState<string>(
        JSON.stringify([request, params, autoExecute])
    );

    const sendRequest = (
        abortCtrl: AbortController,
        reqrequest: EntitiesSkillBasedOnDescriptionRequest,
        reqparams: RequestParams
    ) => {
        if (!api.instance.defaults.headers.common.Authorization) {
            return;
        }

        setState({
            ...state,
            error: undefined,
            isLoading: true,
            isExecuted: true,
        });
        try {
            const reqparamsSignal = { ...reqparams, signal: abortCtrl.signal };
            api.api
                .v1ProfileSkillsDescriptionCreate(reqrequest, reqparamsSignal)
                .then((resp) => {
                    setState({
                        ...state,
                        error: undefined,
                        response: resp.data,
                        isLoading: false,
                        isExecuted: true,
                    });
                })
                .catch((err) => {
                    if (
                        err.name === 'AbortError' ||
                        err.name === 'CanceledError'
                    ) {
                        // Request was aborted
                    } else {
                        setState({
                            ...state,
                            error: err,
                            response: undefined,
                            isLoading: false,
                            isExecuted: true,
                        });
                    }
                });
        } catch (err) {
            setState({
                ...state,
                error: err,
                isLoading: false,
                isExecuted: true,
            });
        }
    };

    if (JSON.stringify([request, params, autoExecute]) !== lastInput) {
        setLastInput(JSON.stringify([request, params, autoExecute]));
    }

    useEffect(() => {
        if (autoExecute) {
            controller.abort();
            const newController = new AbortController();
            setController(newController);
            sendRequest(newController, request, params);
        }
    }, [lastInput]);

    const { response } = state;
    const { isLoading } = state;
    const { isExecuted } = state;
    const { error } = state;
    const sendNow = () => {
        controller.abort();
        const newController = new AbortController();
        setController(newController);
        sendRequest(newController, request, params);
    };

    const sendNowWithParams = (
        reqrequest: EntitiesSkillBasedOnDescriptionRequest,
        reqparams: RequestParams
    ) => {
        controller.abort();
        const newController = new AbortController();
        setController(newController);
        sendRequest(newController, reqrequest, reqparams);
    };

    return {
        response,
        isLoading,
        isExecuted,
        error,
        sendNow,
        sendNowWithParams,
    };
};

interface IuseApiV1ProfileSkillsScoreGraphListState {
    isLoading: boolean;
    isExecuted: boolean;
    response?: EntitiesGetSkillScoreGraphResponse;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    error?: any;
}

/**
 * URL:
 */
export const useApiV1ProfileSkillsScoreGraphList = (
    params: RequestParams = {},
    autoExecute = true
) => {
    const [controller, setController] = useState(new AbortController());

    const api = new Api();
    api.instance = AxiosAPI;

    const [state, setState] =
        useState<IuseApiV1ProfileSkillsScoreGraphListState>({
            isLoading: true,
            isExecuted: false,
        });
    const [lastInput, setLastInput] = useState<string>(
        JSON.stringify([params, autoExecute])
    );

    const sendRequest = (
        abortCtrl: AbortController,
        reqparams: RequestParams
    ) => {
        if (!api.instance.defaults.headers.common.Authorization) {
            return;
        }

        setState({
            ...state,
            error: undefined,
            isLoading: true,
            isExecuted: true,
        });
        try {
            const reqparamsSignal = { ...reqparams, signal: abortCtrl.signal };
            api.api
                .v1ProfileSkillsScoreGraphList(reqparamsSignal)
                .then((resp) => {
                    setState({
                        ...state,
                        error: undefined,
                        response: resp.data,
                        isLoading: false,
                        isExecuted: true,
                    });
                })
                .catch((err) => {
                    if (
                        err.name === 'AbortError' ||
                        err.name === 'CanceledError'
                    ) {
                        // Request was aborted
                    } else {
                        setState({
                            ...state,
                            error: err,
                            response: undefined,
                            isLoading: false,
                            isExecuted: true,
                        });
                    }
                });
        } catch (err) {
            setState({
                ...state,
                error: err,
                isLoading: false,
                isExecuted: true,
            });
        }
    };

    if (JSON.stringify([params, autoExecute]) !== lastInput) {
        setLastInput(JSON.stringify([params, autoExecute]));
    }

    useEffect(() => {
        if (autoExecute) {
            controller.abort();
            const newController = new AbortController();
            setController(newController);
            sendRequest(newController, params);
        }
    }, [lastInput]);

    const { response } = state;
    const { isLoading } = state;
    const { isExecuted } = state;
    const { error } = state;
    const sendNow = () => {
        controller.abort();
        const newController = new AbortController();
        setController(newController);
        sendRequest(newController, params);
    };

    const sendNowWithParams = (reqparams: RequestParams) => {
        controller.abort();
        const newController = new AbortController();
        setController(newController);
        sendRequest(newController, reqparams);
    };

    return {
        response,
        isLoading,
        isExecuted,
        error,
        sendNow,
        sendNowWithParams,
    };
};

interface IuseApiV1ProfileSkillsSuggestCreateState {
    isLoading: boolean;
    isExecuted: boolean;
    response?: EntitiesSuggestNewSkillsResponse;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    error?: any;
}

/**
 * URL:
 */
export const useApiV1ProfileSkillsSuggestCreate = (
    params: RequestParams = {},
    autoExecute = true
) => {
    const [controller, setController] = useState(new AbortController());

    const api = new Api();
    api.instance = AxiosAPI;

    const [state, setState] =
        useState<IuseApiV1ProfileSkillsSuggestCreateState>({
            isLoading: true,
            isExecuted: false,
        });
    const [lastInput, setLastInput] = useState<string>(
        JSON.stringify([params, autoExecute])
    );

    const sendRequest = (
        abortCtrl: AbortController,
        reqparams: RequestParams
    ) => {
        if (!api.instance.defaults.headers.common.Authorization) {
            return;
        }

        setState({
            ...state,
            error: undefined,
            isLoading: true,
            isExecuted: true,
        });
        try {
            const reqparamsSignal = { ...reqparams, signal: abortCtrl.signal };
            api.api
                .v1ProfileSkillsSuggestCreate(reqparamsSignal)
                .then((resp) => {
                    setState({
                        ...state,
                        error: undefined,
                        response: resp.data,
                        isLoading: false,
                        isExecuted: true,
                    });
                })
                .catch((err) => {
                    if (
                        err.name === 'AbortError' ||
                        err.name === 'CanceledError'
                    ) {
                        // Request was aborted
                    } else {
                        setState({
                            ...state,
                            error: err,
                            response: undefined,
                            isLoading: false,
                            isExecuted: true,
                        });
                    }
                });
        } catch (err) {
            setState({
                ...state,
                error: err,
                isLoading: false,
                isExecuted: true,
            });
        }
    };

    if (JSON.stringify([params, autoExecute]) !== lastInput) {
        setLastInput(JSON.stringify([params, autoExecute]));
    }

    useEffect(() => {
        if (autoExecute) {
            controller.abort();
            const newController = new AbortController();
            setController(newController);
            sendRequest(newController, params);
        }
    }, [lastInput]);

    const { response } = state;
    const { isLoading } = state;
    const { isExecuted } = state;
    const { error } = state;
    const sendNow = () => {
        controller.abort();
        const newController = new AbortController();
        setController(newController);
        sendRequest(newController, params);
    };

    const sendNowWithParams = (reqparams: RequestParams) => {
        controller.abort();
        const newController = new AbortController();
        setController(newController);
        sendRequest(newController, reqparams);
    };

    return {
        response,
        isLoading,
        isExecuted,
        error,
        sendNow,
        sendNowWithParams,
    };
};

interface IuseApiV1ProfileSuggestCertificatesCreateState {
    isLoading: boolean;
    isExecuted: boolean;
    response?: EntitiesSuggestNewCertificatesResponse;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    error?: any;
}

/**
 * URL:
 */
export const useApiV1ProfileSuggestCertificatesCreate = (
    params: RequestParams = {},
    autoExecute = true
) => {
    const [controller, setController] = useState(new AbortController());

    const api = new Api();
    api.instance = AxiosAPI;

    const [state, setState] =
        useState<IuseApiV1ProfileSuggestCertificatesCreateState>({
            isLoading: true,
            isExecuted: false,
        });
    const [lastInput, setLastInput] = useState<string>(
        JSON.stringify([params, autoExecute])
    );

    const sendRequest = (
        abortCtrl: AbortController,
        reqparams: RequestParams
    ) => {
        if (!api.instance.defaults.headers.common.Authorization) {
            return;
        }

        setState({
            ...state,
            error: undefined,
            isLoading: true,
            isExecuted: true,
        });
        try {
            const reqparamsSignal = { ...reqparams, signal: abortCtrl.signal };
            api.api
                .v1ProfileSuggestCertificatesCreate(reqparamsSignal)
                .then((resp) => {
                    setState({
                        ...state,
                        error: undefined,
                        response: resp.data,
                        isLoading: false,
                        isExecuted: true,
                    });
                })
                .catch((err) => {
                    if (
                        err.name === 'AbortError' ||
                        err.name === 'CanceledError'
                    ) {
                        // Request was aborted
                    } else {
                        setState({
                            ...state,
                            error: err,
                            response: undefined,
                            isLoading: false,
                            isExecuted: true,
                        });
                    }
                });
        } catch (err) {
            setState({
                ...state,
                error: err,
                isLoading: false,
                isExecuted: true,
            });
        }
    };

    if (JSON.stringify([params, autoExecute]) !== lastInput) {
        setLastInput(JSON.stringify([params, autoExecute]));
    }

    useEffect(() => {
        if (autoExecute) {
            controller.abort();
            const newController = new AbortController();
            setController(newController);
            sendRequest(newController, params);
        }
    }, [lastInput]);

    const { response } = state;
    const { isLoading } = state;
    const { isExecuted } = state;
    const { error } = state;
    const sendNow = () => {
        controller.abort();
        const newController = new AbortController();
        setController(newController);
        sendRequest(newController, params);
    };

    const sendNowWithParams = (reqparams: RequestParams) => {
        controller.abort();
        const newController = new AbortController();
        setController(newController);
        sendRequest(newController, reqparams);
    };

    return {
        response,
        isLoading,
        isExecuted,
        error,
        sendNow,
        sendNowWithParams,
    };
};

interface IuseApiV1SignupEmailCreateState {
    isLoading: boolean;
    isExecuted: boolean;
    response?: void;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    error?: any;
}

/**
 * URL:
 */
export const useApiV1SignupEmailCreate = (
    request: EntitiesSignUpEmailRequest,
    params: RequestParams = {},
    autoExecute = true
) => {
    const [controller, setController] = useState(new AbortController());

    const api = new Api();
    api.instance = AxiosAPI;

    const [state, setState] = useState<IuseApiV1SignupEmailCreateState>({
        isLoading: true,
        isExecuted: false,
    });
    const [lastInput, setLastInput] = useState<string>(
        JSON.stringify([request, params, autoExecute])
    );

    const sendRequest = (
        abortCtrl: AbortController,
        reqrequest: EntitiesSignUpEmailRequest,
        reqparams: RequestParams
    ) => {
        if (!api.instance.defaults.headers.common.Authorization) {
            return;
        }

        setState({
            ...state,
            error: undefined,
            isLoading: true,
            isExecuted: true,
        });
        try {
            const reqparamsSignal = { ...reqparams, signal: abortCtrl.signal };
            api.api
                .v1SignupEmailCreate(reqrequest, reqparamsSignal)
                .then((resp) => {
                    setState({
                        ...state,
                        error: undefined,
                        response: resp.data,
                        isLoading: false,
                        isExecuted: true,
                    });
                })
                .catch((err) => {
                    if (
                        err.name === 'AbortError' ||
                        err.name === 'CanceledError'
                    ) {
                        // Request was aborted
                    } else {
                        setState({
                            ...state,
                            error: err,
                            response: undefined,
                            isLoading: false,
                            isExecuted: true,
                        });
                    }
                });
        } catch (err) {
            setState({
                ...state,
                error: err,
                isLoading: false,
                isExecuted: true,
            });
        }
    };

    if (JSON.stringify([request, params, autoExecute]) !== lastInput) {
        setLastInput(JSON.stringify([request, params, autoExecute]));
    }

    useEffect(() => {
        if (autoExecute) {
            controller.abort();
            const newController = new AbortController();
            setController(newController);
            sendRequest(newController, request, params);
        }
    }, [lastInput]);

    const { response } = state;
    const { isLoading } = state;
    const { isExecuted } = state;
    const { error } = state;
    const sendNow = () => {
        controller.abort();
        const newController = new AbortController();
        setController(newController);
        sendRequest(newController, request, params);
    };

    const sendNowWithParams = (
        reqrequest: EntitiesSignUpEmailRequest,
        reqparams: RequestParams
    ) => {
        controller.abort();
        const newController = new AbortController();
        setController(newController);
        sendRequest(newController, reqrequest, reqparams);
    };

    return {
        response,
        isLoading,
        isExecuted,
        error,
        sendNow,
        sendNowWithParams,
    };
};

interface IuseApiV1SignupPasswordCreateState {
    isLoading: boolean;
    isExecuted: boolean;
    response?: void;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    error?: any;
}

/**
 * URL:
 */
export const useApiV1SignupPasswordCreate = (
    request: EntitiesSignUpPasswordRequest,
    params: RequestParams = {},
    autoExecute = true
) => {
    const [controller, setController] = useState(new AbortController());

    const api = new Api();
    api.instance = AxiosAPI;

    const [state, setState] = useState<IuseApiV1SignupPasswordCreateState>({
        isLoading: true,
        isExecuted: false,
    });
    const [lastInput, setLastInput] = useState<string>(
        JSON.stringify([request, params, autoExecute])
    );

    const sendRequest = (
        abortCtrl: AbortController,
        reqrequest: EntitiesSignUpPasswordRequest,
        reqparams: RequestParams
    ) => {
        setState({
            ...state,
            error: undefined,
            isLoading: true,
            isExecuted: true,
        });
        try {
            const reqparamsSignal = { ...reqparams, signal: abortCtrl.signal };
            api.api
                .v1SignupPasswordCreate(reqrequest, reqparamsSignal)
                .then((resp) => {
                    setState({
                        ...state,
                        error: undefined,
                        response: resp.data,
                        isLoading: false,
                        isExecuted: true,
                    });
                })
                .catch((err) => {
                    if (
                        err.name === 'AbortError' ||
                        err.name === 'CanceledError'
                    ) {
                        // Request was aborted
                    } else {
                        setState({
                            ...state,
                            error: err,
                            response: undefined,
                            isLoading: false,
                            isExecuted: true,
                        });
                    }
                });
        } catch (err) {
            setState({
                ...state,
                error: err,
                isLoading: false,
                isExecuted: true,
            });
        }
    };

    if (JSON.stringify([request, params, autoExecute]) !== lastInput) {
        setLastInput(JSON.stringify([request, params, autoExecute]));
    }

    useEffect(() => {
        if (autoExecute) {
            controller.abort();
            const newController = new AbortController();
            setController(newController);
            sendRequest(newController, request, params);
        }
    }, [lastInput]);

    const { response } = state;
    const { isLoading } = state;
    const { isExecuted } = state;
    const { error } = state;
    const sendNow = () => {
        controller.abort();
        const newController = new AbortController();
        setController(newController);
        sendRequest(newController, request, params);
    };

    const sendNowWithParams = (
        reqrequest: EntitiesSignUpPasswordRequest,
        reqparams: RequestParams
    ) => {
        controller.abort();
        const newController = new AbortController();
        setController(newController);
        sendRequest(newController, reqrequest, reqparams);
    };

    return {
        response,
        isLoading,
        isExecuted,
        error,
        sendNow,
        sendNowWithParams,
    };
};

interface IuseApiV1TtsCreateState {
    isLoading: boolean;
    isExecuted: boolean;
    response?: string;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    error?: any;
}

/**
 * URL:
 */
export const useApiV1TtsCreate = (
    request: EntitiesTTSRequest,
    params: RequestParams = {},
    autoExecute = true
) => {
    const [controller, setController] = useState(new AbortController());

    const api = new Api();
    api.instance = AxiosAPI;

    const [state, setState] = useState<IuseApiV1TtsCreateState>({
        isLoading: true,
        isExecuted: false,
    });
    const [lastInput, setLastInput] = useState<string>(
        JSON.stringify([request, params, autoExecute])
    );

    const sendRequest = (
        abortCtrl: AbortController,
        reqrequest: EntitiesTTSRequest,
        reqparams: RequestParams
    ) => {
        if (!api.instance.defaults.headers.common.Authorization) {
            return;
        }

        setState({
            ...state,
            error: undefined,
            isLoading: true,
            isExecuted: true,
        });
        try {
            const reqparamsSignal = { ...reqparams, signal: abortCtrl.signal };
            api.api
                .v1TtsCreate(reqrequest, reqparamsSignal)
                .then((resp) => {
                    setState({
                        ...state,
                        error: undefined,
                        response: resp.data,
                        isLoading: false,
                        isExecuted: true,
                    });
                })
                .catch((err) => {
                    if (
                        err.name === 'AbortError' ||
                        err.name === 'CanceledError'
                    ) {
                        // Request was aborted
                    } else {
                        setState({
                            ...state,
                            error: err,
                            response: undefined,
                            isLoading: false,
                            isExecuted: true,
                        });
                    }
                });
        } catch (err) {
            setState({
                ...state,
                error: err,
                isLoading: false,
                isExecuted: true,
            });
        }
    };

    if (JSON.stringify([request, params, autoExecute]) !== lastInput) {
        setLastInput(JSON.stringify([request, params, autoExecute]));
    }

    useEffect(() => {
        if (autoExecute) {
            controller.abort();
            const newController = new AbortController();
            setController(newController);
            sendRequest(newController, request, params);
        }
    }, [lastInput]);

    const { response } = state;
    const { isLoading } = state;
    const { isExecuted } = state;
    const { error } = state;
    const sendNow = () => {
        controller.abort();
        const newController = new AbortController();
        setController(newController);
        sendRequest(newController, request, params);
    };

    const sendNowWithParams = (
        reqrequest: EntitiesTTSRequest,
        reqparams: RequestParams
    ) => {
        controller.abort();
        const newController = new AbortController();
        setController(newController);
        sendRequest(newController, reqrequest, reqparams);
    };

    return {
        response,
        isLoading,
        isExecuted,
        error,
        sendNow,
        sendNowWithParams,
    };
};

interface IuseApiV1UserFilesUpdateState {
    isLoading: boolean;
    isExecuted: boolean;
    response?: string;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    error?: any;
}

/**
 * URL:
 */
export const useApiV1UserFilesUpdate = (
    data: {
        file: File;
    },
    params: RequestParams = {},
    autoExecute = true
) => {
    const [controller, setController] = useState(new AbortController());

    const api = new Api();
    api.instance = AxiosAPI;

    const [state, setState] = useState<IuseApiV1UserFilesUpdateState>({
        isLoading: true,
        isExecuted: false,
    });
    const [lastInput, setLastInput] = useState<string>(
        JSON.stringify([data, params, autoExecute])
    );

    const sendRequest = (
        abortCtrl: AbortController,
        reqdata: {
            file: File;
        },
        reqparams: RequestParams
    ) => {
        if (!api.instance.defaults.headers.common.Authorization) {
            return;
        }

        setState({
            ...state,
            error: undefined,
            isLoading: true,
            isExecuted: true,
        });
        try {
            const reqparamsSignal = { ...reqparams, signal: abortCtrl.signal };
            api.api
                .v1UserFilesUpdate(reqdata, reqparamsSignal)
                .then((resp) => {
                    setState({
                        ...state,
                        error: undefined,
                        response: resp.data,
                        isLoading: false,
                        isExecuted: true,
                    });
                })
                .catch((err) => {
                    if (
                        err.name === 'AbortError' ||
                        err.name === 'CanceledError'
                    ) {
                        // Request was aborted
                    } else {
                        setState({
                            ...state,
                            error: err,
                            response: undefined,
                            isLoading: false,
                            isExecuted: true,
                        });
                    }
                });
        } catch (err) {
            setState({
                ...state,
                error: err,
                isLoading: false,
                isExecuted: true,
            });
        }
    };

    if (JSON.stringify([data, params, autoExecute]) !== lastInput) {
        setLastInput(JSON.stringify([data, params, autoExecute]));
    }

    useEffect(() => {
        if (autoExecute) {
            controller.abort();
            const newController = new AbortController();
            setController(newController);
            sendRequest(newController, data, params);
        }
    }, [lastInput]);

    const { response } = state;
    const { isLoading } = state;
    const { isExecuted } = state;
    const { error } = state;
    const sendNow = () => {
        controller.abort();
        const newController = new AbortController();
        setController(newController);
        sendRequest(newController, data, params);
    };

    const sendNowWithParams = (
        reqdata: {
            file: File;
        },
        reqparams: RequestParams
    ) => {
        controller.abort();
        const newController = new AbortController();
        setController(newController);
        sendRequest(newController, reqdata, reqparams);
    };

    return {
        response,
        isLoading,
        isExecuted,
        error,
        sendNow,
        sendNowWithParams,
    };
};

interface IuseApiV1UserFilesDownloadDetailState {
    isLoading: boolean;
    isExecuted: boolean;
    response?: number[];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    error?: any;
}

/**
 * URL:
 */
export const useApiV1UserFilesDownloadDetail = (
    fileId: string,
    params: RequestParams = {},
    autoExecute = true
) => {
    const [controller, setController] = useState(new AbortController());

    const api = new Api();
    api.instance = AxiosAPI;

    const [state, setState] = useState<IuseApiV1UserFilesDownloadDetailState>({
        isLoading: true,
        isExecuted: false,
    });
    const [lastInput, setLastInput] = useState<string>(
        JSON.stringify([fileId, params, autoExecute])
    );

    const sendRequest = (
        abortCtrl: AbortController,
        reqfileId: string,
        reqparams: RequestParams
    ) => {
        if (!api.instance.defaults.headers.common.Authorization) {
            return;
        }

        setState({
            ...state,
            error: undefined,
            isLoading: true,
            isExecuted: true,
        });
        try {
            const reqparamsSignal = { ...reqparams, signal: abortCtrl.signal };
            api.api
                .v1UserFilesDownloadDetail(reqfileId, reqparamsSignal)
                .then((resp) => {
                    setState({
                        ...state,
                        error: undefined,
                        response: resp.data,
                        isLoading: false,
                        isExecuted: true,
                    });
                })
                .catch((err) => {
                    if (
                        err.name === 'AbortError' ||
                        err.name === 'CanceledError'
                    ) {
                        // Request was aborted
                    } else {
                        setState({
                            ...state,
                            error: err,
                            response: undefined,
                            isLoading: false,
                            isExecuted: true,
                        });
                    }
                });
        } catch (err) {
            setState({
                ...state,
                error: err,
                isLoading: false,
                isExecuted: true,
            });
        }
    };

    if (JSON.stringify([fileId, params, autoExecute]) !== lastInput) {
        setLastInput(JSON.stringify([fileId, params, autoExecute]));
    }

    useEffect(() => {
        if (autoExecute) {
            controller.abort();
            const newController = new AbortController();
            setController(newController);
            sendRequest(newController, fileId, params);
        }
    }, [lastInput]);

    const { response } = state;
    const { isLoading } = state;
    const { isExecuted } = state;
    const { error } = state;
    const sendNow = () => {
        controller.abort();
        const newController = new AbortController();
        setController(newController);
        sendRequest(newController, fileId, params);
    };

    const sendNowWithParams = (reqfileId: string, reqparams: RequestParams) => {
        controller.abort();
        const newController = new AbortController();
        setController(newController);
        sendRequest(newController, reqfileId, reqparams);
    };

    return {
        response,
        isLoading,
        isExecuted,
        error,
        sendNow,
        sendNowWithParams,
    };
};

interface IuseApiV1UserFilesDownloadDetail2State {
    isLoading: boolean;
    isExecuted: boolean;
    response?: number[];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    error?: any;
}

/**
 * URL:
 */
export const useApiV1UserFilesDownloadDetail2 = (
    fileId: string,
    userId: string,
    params: RequestParams = {},
    autoExecute = true
) => {
    const [controller, setController] = useState(new AbortController());

    const api = new Api();
    api.instance = AxiosAPI;

    const [state, setState] = useState<IuseApiV1UserFilesDownloadDetail2State>({
        isLoading: true,
        isExecuted: false,
    });
    const [lastInput, setLastInput] = useState<string>(
        JSON.stringify([fileId, userId, params, autoExecute])
    );

    const sendRequest = (
        abortCtrl: AbortController,
        reqfileId: string,
        requserId: string,
        reqparams: RequestParams
    ) => {
        if (!api.instance.defaults.headers.common.Authorization) {
            return;
        }

        setState({
            ...state,
            error: undefined,
            isLoading: true,
            isExecuted: true,
        });
        try {
            const reqparamsSignal = { ...reqparams, signal: abortCtrl.signal };
            api.api
                .v1UserFilesDownloadDetail2(
                    reqfileId,
                    requserId,
                    reqparamsSignal
                )
                .then((resp) => {
                    setState({
                        ...state,
                        error: undefined,
                        response: resp.data,
                        isLoading: false,
                        isExecuted: true,
                    });
                })
                .catch((err) => {
                    if (
                        err.name === 'AbortError' ||
                        err.name === 'CanceledError'
                    ) {
                        // Request was aborted
                    } else {
                        setState({
                            ...state,
                            error: err,
                            response: undefined,
                            isLoading: false,
                            isExecuted: true,
                        });
                    }
                });
        } catch (err) {
            setState({
                ...state,
                error: err,
                isLoading: false,
                isExecuted: true,
            });
        }
    };

    if (JSON.stringify([fileId, userId, params, autoExecute]) !== lastInput) {
        setLastInput(JSON.stringify([fileId, userId, params, autoExecute]));
    }

    useEffect(() => {
        if (autoExecute) {
            controller.abort();
            const newController = new AbortController();
            setController(newController);
            sendRequest(newController, fileId, userId, params);
        }
    }, [lastInput]);

    const { response } = state;
    const { isLoading } = state;
    const { isExecuted } = state;
    const { error } = state;
    const sendNow = () => {
        controller.abort();
        const newController = new AbortController();
        setController(newController);
        sendRequest(newController, fileId, userId, params);
    };

    const sendNowWithParams = (
        reqfileId: string,
        requserId: string,
        reqparams: RequestParams
    ) => {
        controller.abort();
        const newController = new AbortController();
        setController(newController);
        sendRequest(newController, reqfileId, requserId, reqparams);
    };

    return {
        response,
        isLoading,
        isExecuted,
        error,
        sendNow,
        sendNowWithParams,
    };
};

interface IuseApiV1UserForgetCreateState {
    isLoading: boolean;
    isExecuted: boolean;
    response?: void;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    error?: any;
}

/**
 * URL:
 */
export const useApiV1UserForgetCreate = (
    request: EntitiesSignUpEmailRequest,
    params: RequestParams = {},
    autoExecute = true
) => {
    const [controller, setController] = useState(new AbortController());

    const api = new Api();
    api.instance = AxiosAPI;

    const [state, setState] = useState<IuseApiV1UserForgetCreateState>({
        isLoading: true,
        isExecuted: false,
    });
    const [lastInput, setLastInput] = useState<string>(
        JSON.stringify([request, params, autoExecute])
    );

    const sendRequest = (
        abortCtrl: AbortController,
        reqrequest: EntitiesSignUpEmailRequest,
        reqparams: RequestParams
    ) => {
        if (!api.instance.defaults.headers.common.Authorization) {
            return;
        }

        setState({
            ...state,
            error: undefined,
            isLoading: true,
            isExecuted: true,
        });
        try {
            const reqparamsSignal = { ...reqparams, signal: abortCtrl.signal };
            api.api
                .v1UserForgetCreate(reqrequest, reqparamsSignal)
                .then((resp) => {
                    setState({
                        ...state,
                        error: undefined,
                        response: resp.data,
                        isLoading: false,
                        isExecuted: true,
                    });
                })
                .catch((err) => {
                    if (
                        err.name === 'AbortError' ||
                        err.name === 'CanceledError'
                    ) {
                        // Request was aborted
                    } else {
                        setState({
                            ...state,
                            error: err,
                            response: undefined,
                            isLoading: false,
                            isExecuted: true,
                        });
                    }
                });
        } catch (err) {
            setState({
                ...state,
                error: err,
                isLoading: false,
                isExecuted: true,
            });
        }
    };

    if (JSON.stringify([request, params, autoExecute]) !== lastInput) {
        setLastInput(JSON.stringify([request, params, autoExecute]));
    }

    useEffect(() => {
        if (autoExecute) {
            controller.abort();
            const newController = new AbortController();
            setController(newController);
            sendRequest(newController, request, params);
        }
    }, [lastInput]);

    const { response } = state;
    const { isLoading } = state;
    const { isExecuted } = state;
    const { error } = state;
    const sendNow = () => {
        controller.abort();
        const newController = new AbortController();
        setController(newController);
        sendRequest(newController, request, params);
    };

    const sendNowWithParams = (
        reqrequest: EntitiesSignUpEmailRequest,
        reqparams: RequestParams
    ) => {
        controller.abort();
        const newController = new AbortController();
        setController(newController);
        sendRequest(newController, reqrequest, reqparams);
    };

    return {
        response,
        isLoading,
        isExecuted,
        error,
        sendNow,
        sendNowWithParams,
    };
};

interface IuseApiV1UserMeListState {
    isLoading: boolean;
    isExecuted: boolean;
    response?: EntitiesGetMeResponse;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    error?: any;
}

/**
 * URL:
 */
export const useApiV1UserMeList = (
    params: RequestParams = {},
    autoExecute = true
) => {
    const [controller, setController] = useState(new AbortController());

    const api = new Api();
    api.instance = AxiosAPI;

    const [state, setState] = useState<IuseApiV1UserMeListState>({
        isLoading: true,
        isExecuted: false,
    });
    const [lastInput, setLastInput] = useState<string>(
        JSON.stringify([params, autoExecute])
    );

    const sendRequest = (
        abortCtrl: AbortController,
        reqparams: RequestParams
    ) => {
        if (!api.instance.defaults.headers.common.Authorization) {
            return;
        }

        setState({
            ...state,
            error: undefined,
            isLoading: true,
            isExecuted: true,
        });
        try {
            const reqparamsSignal = { ...reqparams, signal: abortCtrl.signal };
            api.api
                .v1UserMeList(reqparamsSignal)
                .then((resp) => {
                    setState({
                        ...state,
                        error: undefined,
                        response: resp.data,
                        isLoading: false,
                        isExecuted: true,
                    });
                })
                .catch((err) => {
                    if (
                        err.name === 'AbortError' ||
                        err.name === 'CanceledError'
                    ) {
                        // Request was aborted
                    } else {
                        setState({
                            ...state,
                            error: err,
                            response: undefined,
                            isLoading: false,
                            isExecuted: true,
                        });
                    }
                });
        } catch (err) {
            setState({
                ...state,
                error: err,
                isLoading: false,
                isExecuted: true,
            });
        }
    };

    if (JSON.stringify([params, autoExecute]) !== lastInput) {
        setLastInput(JSON.stringify([params, autoExecute]));
    }

    useEffect(() => {
        if (autoExecute) {
            controller.abort();
            const newController = new AbortController();
            setController(newController);
            sendRequest(newController, params);
        }
    }, [lastInput]);

    const { response } = state;
    const { isLoading } = state;
    const { isExecuted } = state;
    const { error } = state;
    const sendNow = () => {
        controller.abort();
        const newController = new AbortController();
        setController(newController);
        sendRequest(newController, params);
    };

    const sendNowWithParams = (reqparams: RequestParams) => {
        controller.abort();
        const newController = new AbortController();
        setController(newController);
        sendRequest(newController, reqparams);
    };

    return {
        response,
        isLoading,
        isExecuted,
        error,
        sendNow,
        sendNowWithParams,
    };
};

interface IuseApiV1UserMeCreateState {
    isLoading: boolean;
    isExecuted: boolean;
    response?: void;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    error?: any;
}

/**
 * URL:
 */
export const useApiV1UserMeCreate = (
    request: EntitiesUpdateMeRequest,
    params: RequestParams = {},
    autoExecute = true
) => {
    const [controller, setController] = useState(new AbortController());

    const api = new Api();
    api.instance = AxiosAPI;

    const [state, setState] = useState<IuseApiV1UserMeCreateState>({
        isLoading: true,
        isExecuted: false,
    });
    const [lastInput, setLastInput] = useState<string>(
        JSON.stringify([request, params, autoExecute])
    );

    const sendRequest = (
        abortCtrl: AbortController,
        reqrequest: EntitiesUpdateMeRequest,
        reqparams: RequestParams
    ) => {
        if (!api.instance.defaults.headers.common.Authorization) {
            return;
        }

        setState({
            ...state,
            error: undefined,
            isLoading: true,
            isExecuted: true,
        });
        try {
            const reqparamsSignal = { ...reqparams, signal: abortCtrl.signal };
            api.api
                .v1UserMeCreate(reqrequest, reqparamsSignal)
                .then((resp) => {
                    setState({
                        ...state,
                        error: undefined,
                        response: resp.data,
                        isLoading: false,
                        isExecuted: true,
                    });
                })
                .catch((err) => {
                    if (
                        err.name === 'AbortError' ||
                        err.name === 'CanceledError'
                    ) {
                        // Request was aborted
                    } else {
                        setState({
                            ...state,
                            error: err,
                            response: undefined,
                            isLoading: false,
                            isExecuted: true,
                        });
                    }
                });
        } catch (err) {
            setState({
                ...state,
                error: err,
                isLoading: false,
                isExecuted: true,
            });
        }
    };

    if (JSON.stringify([request, params, autoExecute]) !== lastInput) {
        setLastInput(JSON.stringify([request, params, autoExecute]));
    }

    useEffect(() => {
        if (autoExecute) {
            controller.abort();
            const newController = new AbortController();
            setController(newController);
            sendRequest(newController, request, params);
        }
    }, [lastInput]);

    const { response } = state;
    const { isLoading } = state;
    const { isExecuted } = state;
    const { error } = state;
    const sendNow = () => {
        controller.abort();
        const newController = new AbortController();
        setController(newController);
        sendRequest(newController, request, params);
    };

    const sendNowWithParams = (
        reqrequest: EntitiesUpdateMeRequest,
        reqparams: RequestParams
    ) => {
        controller.abort();
        const newController = new AbortController();
        setController(newController);
        sendRequest(newController, reqrequest, reqparams);
    };

    return {
        response,
        isLoading,
        isExecuted,
        error,
        sendNow,
        sendNowWithParams,
    };
};

interface IuseApiV1UserMeDeleteState {
    isLoading: boolean;
    isExecuted: boolean;
    response?: void;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    error?: any;
}

/**
 * URL:
 */
export const useApiV1UserMeDelete = (
    params: RequestParams = {},
    autoExecute = true
) => {
    const [controller, setController] = useState(new AbortController());

    const api = new Api();
    api.instance = AxiosAPI;

    const [state, setState] = useState<IuseApiV1UserMeDeleteState>({
        isLoading: true,
        isExecuted: false,
    });
    const [lastInput, setLastInput] = useState<string>(
        JSON.stringify([params, autoExecute])
    );

    const sendRequest = (
        abortCtrl: AbortController,
        reqparams: RequestParams
    ) => {
        if (!api.instance.defaults.headers.common.Authorization) {
            return;
        }

        setState({
            ...state,
            error: undefined,
            isLoading: true,
            isExecuted: true,
        });
        try {
            const reqparamsSignal = { ...reqparams, signal: abortCtrl.signal };
            api.api
                .v1UserMeDelete(reqparamsSignal)
                .then((resp) => {
                    setState({
                        ...state,
                        error: undefined,
                        response: resp.data,
                        isLoading: false,
                        isExecuted: true,
                    });
                })
                .catch((err) => {
                    if (
                        err.name === 'AbortError' ||
                        err.name === 'CanceledError'
                    ) {
                        // Request was aborted
                    } else {
                        setState({
                            ...state,
                            error: err,
                            response: undefined,
                            isLoading: false,
                            isExecuted: true,
                        });
                    }
                });
        } catch (err) {
            setState({
                ...state,
                error: err,
                isLoading: false,
                isExecuted: true,
            });
        }
    };

    if (JSON.stringify([params, autoExecute]) !== lastInput) {
        setLastInput(JSON.stringify([params, autoExecute]));
    }

    useEffect(() => {
        if (autoExecute) {
            controller.abort();
            const newController = new AbortController();
            setController(newController);
            sendRequest(newController, params);
        }
    }, [lastInput]);

    const { response } = state;
    const { isLoading } = state;
    const { isExecuted } = state;
    const { error } = state;
    const sendNow = () => {
        controller.abort();
        const newController = new AbortController();
        setController(newController);
        sendRequest(newController, params);
    };

    const sendNowWithParams = (reqparams: RequestParams) => {
        controller.abort();
        const newController = new AbortController();
        setController(newController);
        sendRequest(newController, reqparams);
    };

    return {
        response,
        isLoading,
        isExecuted,
        error,
        sendNow,
        sendNowWithParams,
    };
};

interface IuseApiV1UserPasswordCreateState {
    isLoading: boolean;
    isExecuted: boolean;
    response?: void;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    error?: any;
}

/**
 * URL:
 */
export const useApiV1UserPasswordCreate = (
    request: EntitiesChangePasswordRequest,
    params: RequestParams = {},
    autoExecute = true
) => {
    const [controller, setController] = useState(new AbortController());

    const api = new Api();
    api.instance = AxiosAPI;

    const [state, setState] = useState<IuseApiV1UserPasswordCreateState>({
        isLoading: true,
        isExecuted: false,
    });
    const [lastInput, setLastInput] = useState<string>(
        JSON.stringify([request, params, autoExecute])
    );

    const sendRequest = (
        abortCtrl: AbortController,
        reqrequest: EntitiesChangePasswordRequest,
        reqparams: RequestParams
    ) => {
        if (!api.instance.defaults.headers.common.Authorization) {
            return;
        }

        setState({
            ...state,
            error: undefined,
            isLoading: true,
            isExecuted: true,
        });
        try {
            const reqparamsSignal = { ...reqparams, signal: abortCtrl.signal };
            api.api
                .v1UserPasswordCreate(reqrequest, reqparamsSignal)
                .then((resp) => {
                    setState({
                        ...state,
                        error: undefined,
                        response: resp.data,
                        isLoading: false,
                        isExecuted: true,
                    });
                })
                .catch((err) => {
                    if (
                        err.name === 'AbortError' ||
                        err.name === 'CanceledError'
                    ) {
                        // Request was aborted
                    } else {
                        setState({
                            ...state,
                            error: err,
                            response: undefined,
                            isLoading: false,
                            isExecuted: true,
                        });
                    }
                });
        } catch (err) {
            setState({
                ...state,
                error: err,
                isLoading: false,
                isExecuted: true,
            });
        }
    };

    if (JSON.stringify([request, params, autoExecute]) !== lastInput) {
        setLastInput(JSON.stringify([request, params, autoExecute]));
    }

    useEffect(() => {
        if (autoExecute) {
            controller.abort();
            const newController = new AbortController();
            setController(newController);
            sendRequest(newController, request, params);
        }
    }, [lastInput]);

    const { response } = state;
    const { isLoading } = state;
    const { isExecuted } = state;
    const { error } = state;
    const sendNow = () => {
        controller.abort();
        const newController = new AbortController();
        setController(newController);
        sendRequest(newController, request, params);
    };

    const sendNowWithParams = (
        reqrequest: EntitiesChangePasswordRequest,
        reqparams: RequestParams
    ) => {
        controller.abort();
        const newController = new AbortController();
        setController(newController);
        sendRequest(newController, reqrequest, reqparams);
    };

    return {
        response,
        isLoading,
        isExecuted,
        error,
        sendNow,
        sendNowWithParams,
    };
};

interface IuseApiV1WsListState {
    isLoading: boolean;
    isExecuted: boolean;
    response?: EntitiesResponseMessage;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    error?: any;
}

/**
 * URL:
 */
export const useApiV1WsList = (
    request: EntitiesRequestMessage,
    params: RequestParams = {},
    autoExecute = true
) => {
    const [controller, setController] = useState(new AbortController());

    const api = new Api();
    api.instance = AxiosAPI;

    const [state, setState] = useState<IuseApiV1WsListState>({
        isLoading: true,
        isExecuted: false,
    });
    const [lastInput, setLastInput] = useState<string>(
        JSON.stringify([request, params, autoExecute])
    );

    const sendRequest = (
        abortCtrl: AbortController,
        reqrequest: EntitiesRequestMessage,
        reqparams: RequestParams
    ) => {
        if (!api.instance.defaults.headers.common.Authorization) {
            return;
        }

        setState({
            ...state,
            error: undefined,
            isLoading: true,
            isExecuted: true,
        });
        try {
            const reqparamsSignal = { ...reqparams, signal: abortCtrl.signal };
            api.api
                .v1WsList(reqrequest, reqparamsSignal)
                .then((resp) => {
                    setState({
                        ...state,
                        error: undefined,
                        response: resp.data,
                        isLoading: false,
                        isExecuted: true,
                    });
                })
                .catch((err) => {
                    if (
                        err.name === 'AbortError' ||
                        err.name === 'CanceledError'
                    ) {
                        // Request was aborted
                    } else {
                        setState({
                            ...state,
                            error: err,
                            response: undefined,
                            isLoading: false,
                            isExecuted: true,
                        });
                    }
                });
        } catch (err) {
            setState({
                ...state,
                error: err,
                isLoading: false,
                isExecuted: true,
            });
        }
    };

    if (JSON.stringify([request, params, autoExecute]) !== lastInput) {
        setLastInput(JSON.stringify([request, params, autoExecute]));
    }

    useEffect(() => {
        if (autoExecute) {
            controller.abort();
            const newController = new AbortController();
            setController(newController);
            sendRequest(newController, request, params);
        }
    }, [lastInput]);

    const { response } = state;
    const { isLoading } = state;
    const { isExecuted } = state;
    const { error } = state;
    const sendNow = () => {
        controller.abort();
        const newController = new AbortController();
        setController(newController);
        sendRequest(newController, request, params);
    };

    const sendNowWithParams = (
        reqrequest: EntitiesRequestMessage,
        reqparams: RequestParams
    ) => {
        controller.abort();
        const newController = new AbortController();
        setController(newController);
        sendRequest(newController, reqrequest, reqparams);
    };

    return {
        response,
        isLoading,
        isExecuted,
        error,
        sendNow,
        sendNowWithParams,
    };
};
